<template>
  <v-container class="mt-4 px-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-toolbar flat>
            <v-icon left color="blue darken-2">mdi-brain</v-icon>
            <v-toolbar-title>Centro de Inteligencia Meta Ads</v-toolbar-title>
            <v-btn-toggle
              :value="escuela"
              mandatory
              rounded
              dense
              class="ml-4"
              color="blue darken-2"
              @change="cambiarEscuela"
            >
              <v-btn value="inbi" small>INBI</v-btn>
              <v-btn value="fast" small>FAST</v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>
            <v-btn small tile color="blue darken-2" dark class="mr-2" @click="$refs.consultor.abrir()">
              <v-icon left small>mdi-robot-outline</v-icon>
              Consultor IA
            </v-btn>
            <template v-if="indicadores">
              <v-btn small tile color="green darken-1" dark class="mr-2" @click="descargarExcel">
                <v-icon left small>mdi-microsoft-excel</v-icon>
                Excel
              </v-btn>
              <v-btn small tile color="blue-grey darken-1" dark @click="descargarJSON">
                <v-icon left small>mdi-code-json</v-icon>
                JSON
              </v-btn>
            </template>
          </v-toolbar>

          <v-card-text>
            <v-row align="center" dense>
              <v-col cols="6" sm="3" lg="2">
                <v-text-field
                  v-model="fechaDesde"
                  label="Desde"
                  type="date"
                  :max="fechaHasta || fechaMaxima"
                  filled
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="3" lg="2">
                <v-text-field
                  v-model="fechaHasta"
                  label="Hasta"
                  type="date"
                  :min="fechaDesde"
                  :max="fechaMaxima"
                  filled
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="auto">
                <v-btn-toggle :value="accesoRapido" dense tile color="blue darken-2" class="mr-2">
                  <v-btn v-for="a in ACCESOS_RAPIDOS" :key="a.clave" :value="a.clave" small @click="rangoRapido(a)">
                    {{ a.texto }}
                  </v-btn>
                </v-btn-toggle>
              </v-col>
              <v-col cols="12" sm="auto">
                <v-switch v-model="comparar" label="Comparar con periodo anterior" dense hide-details class="mt-0 mr-3"></v-switch>
              </v-col>
              <v-col cols="12" sm="auto">
                <v-btn color="primary" small tile @click="consultar">
                  <v-icon left small>mdi-refresh</v-icon>
                  Consultar
                </v-btn>
              </v-col>
            </v-row>

            <div v-if="indicadores" class="mt-3">
              <v-chip small class="mr-2" color="blue darken-2" dark>{{ textoRango }}</v-chip>
              <v-chip v-if="anterior" small class="mr-2" color="blue lighten-4">
                vs {{ anterior.rango.desde }} al {{ anterior.rango.hasta }}
                <span v-if="comparacionParcial">&nbsp;(día en curso: comparación parcial)</span>
              </v-chip>
              <template v-if="actualizacion">
                <v-chip v-if="actualizacion.provisional" small class="mr-2" color="orange lighten-4">
                  <v-icon left small>mdi-progress-clock</v-icon>
                  Provisional · se actualiza cada 30 min
                </v-chip>
                <v-chip small class="mr-2" :color="COLOR_SYNC[actualizacion.estado_general]">
                  <v-icon left small>mdi-sync</v-icon>
                  Actualización: {{ TEXTO_SYNC[actualizacion.estado_general] || '-' }}
                </v-chip>
                <v-chip
                  v-for="f in fuentesActualizacion"
                  :key="f.clave"
                  small
                  class="mr-2"
                  :color="f.estado === 'ERROR' ? 'red lighten-4' : 'grey lighten-3'"
                  :title="f.detalle"
                >
                  <v-icon v-if="f.estado === 'ERROR'" left small color="red darken-2">mdi-alert</v-icon>
                  {{ f.texto }}
                </v-chip>
              </template>
              <v-chip v-else small class="mr-2" color="grey lighten-2">
                <v-icon left small>mdi-clock-outline</v-icon>
                Generado: {{ textoGeneracion }}
              </v-chip>
              <v-chip v-if="integridad" small class="mr-2" :color="COLOR_INTEGRIDAD[integridad.estado]" :dark="integridad.estado === 'SIN_DATOS'">
                <v-icon left small>{{ integridad.estado === 'COMPLETO' ? 'mdi-check-decagram' : 'mdi-alert-decagram' }}</v-icon>
                Datos: {{ TEXTO_INTEGRIDAD[integridad.estado] }}
              </v-chip>
              <v-chip small class="mr-2" :color="indicadores.fuente_gasto === 'ads_insights' ? 'green lighten-4' : 'amber lighten-3'">
                Inversión: {{ textoFuenteGasto }}
              </v-chip>
              <v-chip v-if="indicadores.reconstruido" small class="mr-2" color="amber lighten-3">
                <v-icon left small>mdi-history</v-icon>
                Reconstruido
              </v-chip>
              <v-chip v-if="conciliacion" small class="mr-2" :color="conciliacion.coincide ? 'green lighten-4' : 'red lighten-4'">
                <v-icon left small>{{ conciliacion.coincide ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
                Meta en vivo {{ formatoMoneda(conciliacion.total_meta_en_vivo) }}
                <span v-if="!conciliacion.coincide">&nbsp;· diferencia {{ formatoMoneda(conciliacion.diferencia) }}</span>
              </v-chip>
              <v-btn v-else small text color="blue darken-2" :loading="conciliando" @click="conciliar">
                <v-icon left small>mdi-scale-balance</v-icon>
                Conciliar con Meta
              </v-btn>
            </div>

            <v-alert v-if="sinReporte" type="info" text dense class="mt-4 mb-0">
              No hay datos de {{ escuela.toUpperCase() }} del {{ fechaDesde }} al {{ fechaHasta }}.
              El día en curso se actualiza cada 30 minutos y el reporte oficial se genera cada mañana con los datos del día anterior.
            </v-alert>
            <template v-else-if="indicadores">
              <v-alert v-if="fuentesConError.length" type="warning" text dense class="mt-4 mb-0">
                <div v-for="f in fuentesConError" :key="f.clave">
                  <strong>{{ f.nombre }}:</strong> {{ f.detalle }}
                </div>
              </v-alert>
              <v-alert v-if="diasIncompletos.length" :type="crmDisponible ? 'warning' : 'error'" text dense class="mt-4 mb-0">
                <div v-for="(a, i) in integridad.advertencias" :key="i" class="font-weight-medium">{{ a }}</div>
                <div class="mt-1">
                  <div v-for="d in diasIncompletos" :key="d.fecha" class="caption">
                    <strong>{{ d.fecha }}</strong> · {{ TEXTO_INTEGRIDAD[d.estado] }} · falta: {{ d.faltan_texto.join(', ') }}
                  </div>
                </div>
              </v-alert>
              <v-alert v-else-if="indicadores.dias_sin_reporte.length" type="warning" text dense class="mt-4 mb-0">
                Sin reporte del Analyzer: {{ indicadores.dias_sin_reporte.join(', ') }}.
                Prospectos, completos e inscritos de esos días no están incluidos.
              </v-alert>
              <v-alert v-if="indicadores.dias_sin_historico_meta.length" type="warning" text dense class="mt-4 mb-0">
                Sin histórico diario de Meta: {{ indicadores.dias_sin_historico_meta.join(', ') }}.
                La inversión se toma de los reportes del Analyzer y no hay impresiones, CTR ni CPM del periodo.
              </v-alert>
              <v-alert v-if="anteriorIncompleto" type="warning" text dense class="mt-4 mb-0">
                El periodo anterior está incompleto ({{ anteriorIncompleto }}): la comparación es solo de referencia.
              </v-alert>
            </template>
          </v-card-text>

          <template v-if="indicadores">
            <v-card-text class="pt-0">
              <v-row dense align="center">
                <v-col cols="6" sm="3" md="2">
                  <v-select v-model="filtroSucursal" :items="opcionesSucursal" label="Sucursal (anuncio)" clearable filled dense hide-details></v-select>
                </v-col>
                <v-col cols="6" sm="3" md="2">
                  <v-select v-model="filtroProducto" :items="opcionesProducto" label="Producto" clearable filled dense hide-details></v-select>
                </v-col>
                <v-col cols="6" sm="3" md="2">
                  <v-select v-model="filtroCiudad" :items="opcionesCiudad" label="Ciudad" clearable filled dense hide-details></v-select>
                </v-col>
                <v-col cols="6" sm="3" md="2">
                  <v-select v-model="filtroEstratega" :items="opcionesEstratega" label="Estratega" clearable filled dense hide-details></v-select>
                </v-col>
                <v-col v-if="filtroAnuncio" cols="12" sm="auto">
                  <v-chip small close color="blue lighten-4" @click:close="filtroAnuncio = null">
                    <v-icon left small>mdi-bullhorn</v-icon>
                    Anuncio: {{ nombreFiltroAnuncio }}
                  </v-chip>
                </v-col>
                <v-col v-if="hayFiltros" cols="12" sm="auto">
                  <v-btn small text color="blue darken-2" @click="limpiarFiltros">
                    <v-icon left small>mdi-filter-remove</v-icon>
                    Limpiar filtros
                  </v-btn>
                </v-col>
              </v-row>
              <div v-if="hayFiltros" class="caption mt-2">
                <strong>Filtrado:</strong>
                {{ formatear(resumenFiltro.anuncios, 'entero') }} anuncios · inversión {{ formatoMoneda(resumenFiltro.gasto) }}
                · prospectos {{ formatear(resumenFiltro.prospectos, 'entero') }}
                · nuevos completos {{ formatear(resumenFiltro.nuevos_completos, 'entero') }}
                · costo por nuevo completo {{ formatear(resumenFiltro.costo_por_nuevo_completo, 'moneda') }}
                · inscritos {{ formatear(resumenFiltro.inscritos, 'entero') }}
                · ingresos {{ formatear(resumenFiltro.ingresos_primer_pago, 'moneda') }}
                <div class="grey--text">Aplica a Sucursales, Estrategas, Anuncios y Prospectos. Las tarjetas de Dirección y Vendedoras son del total de la marca.</div>
              </div>
            </v-card-text>
            <v-tabs v-model="tab" color="blue darken-2" show-arrows>
              <v-tab><v-icon left small>mdi-view-dashboard</v-icon>Dirección</v-tab>
              <v-tab><v-icon left small>mdi-office-building</v-icon>Sucursales</v-tab>
              <v-tab><v-icon left small>mdi-account-star</v-icon>Estrategas</v-tab>
              <v-tab><v-icon left small>mdi-table</v-icon>Estrategas lista</v-tab>
              <v-tab><v-icon left small>mdi-bullhorn</v-icon>Anuncios</v-tab>
              <v-tab><v-icon left small>mdi-account-tie</v-icon>Vendedoras</v-tab>
              <v-tab><v-icon left small>mdi-account-search</v-icon>Prospectos</v-tab>
              <v-tab><v-icon left small>mdi-checkbox-marked-outline</v-icon>Checklist</v-tab>
              <v-tab><v-icon left small>mdi-book-open-variant</v-icon>Leyenda</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <!-- DIRECCIÓN -->
              <v-tab-item>
                <v-card-text>
                  <v-row dense>
                    <v-col v-for="t in tarjetasDireccion" :key="t.clave" cols="6" sm="4" md="3" lg="2">
                      <v-card outlined class="fill-height" @click="t.detalle && abrirDetalle(t.detalle)">
                        <v-card-text class="pa-3">
                          <div class="caption grey--text text--darken-1">{{ t.titulo }}</div>
                          <div class="text-h6 font-weight-bold">{{ t.valor }}</div>
                          <div v-if="t.motivo" class="caption orange--text text--darken-3">{{ t.motivo }}</div>
                          <div v-else-if="t.nota" class="caption grey--text">{{ t.nota }}</div>
                          <div v-if="anterior" class="caption">
                            <span class="grey--text">Antes {{ t.anterior }}</span>
                            <span v-if="t.variacion !== null" :class="t.neutral ? 'grey--text text--darken-2' : claseVariacion(t.variacion, t.invertir)">
                              {{ t.variacion > 0 ? '▲' : t.variacion < 0 ? '▼' : '' }} {{ Math.abs(t.variacion) }} %
                            </span>
                          </div>
                          <div v-if="t.detalle" class="caption blue--text text--darken-2">
                            <v-icon x-small color="blue darken-2">mdi-magnify</v-icon> Ver detalle
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-tab-item>

              <!-- SUCURSALES -->
              <v-tab-item>
                <v-card-text>
                  <v-alert type="info" text dense>
                    <strong>Inversión:</strong> por plantel del nombre de la campaña (si la campaña no lo trae, el del conjunto).
                    <strong>Prospectos, completos, inscritos e ingresos:</strong> siguen al anuncio que trajo al contacto, así que cada fila es la suma de sus anuncios.
                    Clic en una sucursal para ver sus anuncios; la pestaña Prospectos queda filtrada igual.
                  </v-alert>
                  <v-alert v-if="filtroProducto" type="info" text dense>
                    Con filtro de producto, cada fila suma solo los anuncios de {{ filtroProducto }} (sin presupuesto ni variación).
                  </v-alert>
                  <v-data-table
                    :headers="headersSucursalesVista"
                    :items="sucursalesVista"
                    item-key="sucursal"
                    sort-by="gasto"
                    sort-desc
                    dense
                    class="elevation-0"
                    :items-per-page="-1"
                    hide-default-footer
                    mobile-breakpoint="0"
                  >
                    <template v-for="col in columnasInscritosAyuda" v-slot:[`header.${col}`]="{ header }">
                      <span :key="'hs-' + col" :title="header.ayuda || header.text">{{ header.text }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                      <tr class="fila-clic" @click="verSucursal(item)">
                        <td v-for="h in headersSucursalesVista" :key="h.value" :class="celdaClase(h, item)">
                          {{ formatear(item[h.value], h.formato) }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-tab-item>

              <!-- ESTRATEGAS -->
              <v-tab-item>
                <v-card-text>
                  <v-alert type="info" text dense>
                    Suma de las sucursales que cada estratega tiene asignadas en Optimización de campañas.
                    <strong>Inversión:</strong> por plantel de la campaña.
                    <strong>Contactos:</strong> prospectos nuevos + rezagados del periodo atribuidos a anuncios Meta de esas sucursales (día del primer mensaje).
                    <strong>Inscritos en periodo (de contactos):</strong> de esos Contactos, cuántos tienen primer pago dentro del periodo.
                    <strong>Completos:</strong> de quienes escribieron vía Meta (nuevo/rezagado/reingreso) y completaron su registro.
                    <strong>Inscritos atribuidos (pagos Meta del periodo):</strong> alta + primer pago en el periodo con anuncio Meta ≤ 90 días (otra población; pudo contactar antes).
                    "Sin estratega asignado" agrupa sucursales sin responsable y anuncios sin sucursal reconocida.
                    Clic en los chips de contactos/inscritos/completos para ver folios y fechas; clic en la tarjeta para filtrar anuncios.
                  </v-alert>
                  <v-alert v-if="!estrategas" type="warning" text dense>
                    No se pudo leer la asignación de estrategas por sucursal.
                  </v-alert>
                  <v-row v-else dense>
                    <v-col v-for="e in estrategasVista" :key="e.clave" cols="12" sm="6" lg="4">
                      <v-card outlined class="fill-height" @click="verEstratega(e)">
                        <v-card-title class="subtitle-1 font-weight-bold pb-1">
                          <v-icon left color="blue darken-2">{{ e.id_usuario ? 'mdi-account-star' : 'mdi-account-question' }}</v-icon>
                          {{ e.estratega }}
                        </v-card-title>
                        <v-card-text class="pb-2">
                          <div class="mb-2">
                            <v-chip v-for="s in e.sucursales" :key="s" x-small class="mr-1 mb-1" color="blue lighten-5">{{ s }}</v-chip>
                          </div>
                          <v-row dense>
                            <v-col v-for="k in e.kpis" :key="k.campo" cols="4">
                              <div class="caption grey--text text--darken-1" :title="k.ayuda || k.titulo">{{ k.titulo }}</div>
                              <v-chip
                                v-if="esMetricaCrm(k.campo)"
                                small
                                dense
                                color="primary"
                                dark
                                class="ma-0 mt-1"
                                @click.stop="abrirDetalleCrmEstratega(e, k.campo)"
                              >{{ k.valor }}</v-chip>
                              <div v-else class="body-1 font-weight-bold">{{ k.valor }}</div>
                              <div v-if="k.motivo" class="caption orange--text text--darken-3">{{ k.motivo }}</div>
                              <div v-else-if="anterior && k.variacion !== null" class="caption" :class="k.neutral ? 'grey--text text--darken-2' : claseVariacion(k.variacion, k.invertir)">
                                {{ k.variacion > 0 ? '▲' : k.variacion < 0 ? '▼' : '' }} {{ Math.abs(k.variacion) }} %
                              </div>
                            </v-col>
                          </v-row>
                          <div v-if="e.resumen" class="caption mt-2">{{ e.resumen }}</div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-tab-item>

              <!-- ESTRATEGAS LISTA -->
              <v-tab-item>
                <v-card-text>
                  <v-alert type="info" text dense>
                    Misma información que Estrategas, en tabla para ordenar por columna.
                    <strong>Contactos</strong> = nuevos + rezagados Meta del periodo (día del mensaje).
                    <strong>Inscritos en periodo (de contactos)</strong> = de esos contactos, quiénes pagaron dentro del rango.
                    <strong>Completos</strong> = registro completo tras escribir por Meta.
                    <strong>Inscritos atribuidos (pagos Meta del periodo)</strong> = pagos del periodo atribuidos a Meta (no es la misma cohorte).
                    Clic en esos chips para ver quiénes son (folio, fechas, anuncio); clic en el resto de la fila para filtrar anuncios.
                  </v-alert>
                  <v-alert v-if="!estrategas" type="warning" text dense>
                    No se pudo leer la asignación de estrategas por sucursal.
                  </v-alert>
                  <v-data-table
                    v-else
                    :headers="headersEstrategasLista"
                    :items="estrategasVista"
                    item-key="clave"
                    sort-by="gasto"
                    sort-desc
                    dense
                    class="elevation-0"
                    :items-per-page="-1"
                    hide-default-footer
                    mobile-breakpoint="0"
                  >
                    <template v-for="col in columnasInscritosAyuda" v-slot:[`header.${col}`]="{ header }">
                      <span :key="'he-' + col" :title="header.ayuda || header.text">{{ header.text }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                      <tr class="fila-clic" @click="verEstratega(item)">
                        <td v-for="h in headersEstrategasLista" :key="h.value" :class="celdaClase(h, item)">
                          <template v-if="h.value === 'estratega'">
                            <v-icon small class="mr-1" :color="item.id_usuario ? 'blue darken-2' : 'grey'">
                              {{ item.id_usuario ? 'mdi-account-star' : 'mdi-account-question' }}
                            </v-icon>
                            {{ item.estratega }}
                          </template>
                          <template v-else-if="h.value === 'sucursales_texto'">
                            <v-chip
                              v-for="s in item.sucursales"
                              :key="s"
                              x-small
                              class="mr-1 mb-1"
                              color="blue lighten-5"
                            >{{ s }}</v-chip>
                          </template>
                          <v-chip
                            v-else-if="esMetricaCrm(h.value)"
                            small
                            dense
                            color="primary"
                            dark
                            class="ma-0"
                            @click.stop="abrirDetalleCrmEstratega(item, h.value)"
                          >{{ formatear(item[h.value], h.formato) }}</v-chip>
                          <template v-else>
                            {{ formatear(item[h.value], h.formato) }}
                          </template>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-tab-item>

              <!-- ANUNCIOS -->
              <v-tab-item>
                <v-card-text>
                  <v-row dense align="center">
                    <v-col cols="12" sm="auto">
                      <v-btn-toggle v-model="vistaAnuncios" mandatory dense tile color="blue darken-2">
                        <v-btn value="anuncio" small>Por anuncio</v-btn>
                        <v-btn value="conjunto" small>Por conjunto</v-btn>
                      </v-btn-toggle>
                    </v-col>
                    <v-col cols="12" sm="5">
                      <v-select v-model="filtroCampania" :items="opcionesCampania" label="Campaña" clearable filled dense hide-details></v-select>
                    </v-col>
                    <v-col cols="12" sm>
                      <v-text-field v-model="buscarAnuncio" label="Buscar" append-icon="mdi-magnify" clearable filled dense hide-details></v-text-field>
                    </v-col>
                  </v-row>
                  <div v-if="!crmCompleto" class="my-3">
                    <v-chip small color="grey lighten-2">
                      <v-icon left small>mdi-bell-off-outline</v-icon>
                      Alertas por anuncio desactivadas: faltan datos del CRM en el periodo
                    </v-chip>
                  </div>
                  <div v-else class="my-3">
                    <v-chip small color="red lighten-4" class="mr-2">
                      Gasto ≥ {{ formatoMoneda(umbralGastoSinCompletos) }} y 0 completos: {{ conteoAlertas.gasto }}
                    </v-chip>
                    <v-chip small color="orange lighten-4">
                      ≥ {{ umbralConversaciones }} conversaciones y menos de {{ umbralPctCompletos }} % completos: {{ conteoAlertas.conversaciones }}
                    </v-chip>
                    <span v-if="vistaAnuncios === 'anuncio'" class="caption grey--text ml-2">
                      Clic en un anuncio para ver su contenido. Chips de Nuevos / Rezagados / Completos / Inscritos / seguimiento abren el listado con folio y fechas.
                    </span>
                  </div>
                  <v-data-table
                    :headers="headersAnunciosVista"
                    :items="filasAnuncios"
                    :item-key="vistaAnuncios === 'anuncio' ? 'ad_id' : 'clave'"
                    :search="buscarAnuncio"
                    sort-by="gasto"
                    sort-desc
                    dense
                    class="elevation-0"
                    :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
                    :items-per-page="25"
                    mobile-breakpoint="0"
                  >
                    <template v-for="col in columnasInscritosAyuda" v-slot:[`header.${col}`]="{ header }">
                      <span :key="'ha-' + col" :title="header.ayuda || header.text">{{ header.text }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                      <tr :class="[claseAlerta(item), vistaAnuncios === 'anuncio' ? 'fila-clic' : '']" @click="abrirAnuncio(item)">
                        <td v-for="h in headersAnunciosVista" :key="h.value" :class="celdaClase(h, item)">
                          <div v-if="esColumnaSeguimiento(h.value)" class="text-right">
                            <v-chip
                              small
                              dense
                              color="primary"
                              dark
                              class="ma-0"
                              @click.stop="abrirSeguimientoAnuncio(item, h.value)"
                            >{{ textoConteoSeguimiento(item, h.value) }}</v-chip>
                            <div class="caption black--text">{{ textoPctSeguimiento(item, h.value) }}</div>
                          </div>
                          <v-chip
                            v-else-if="esMetricaCrm(h.value) || h.value === 'prospectos_nuevos' || h.value === 'rezagados' || h.value === 'inscritos_cohorte_periodo'"
                            small
                            dense
                            color="primary"
                            dark
                            class="ma-0"
                            @click.stop="abrirDetalleCrmAnuncio(item, h.value)"
                          >{{ formatear(item[h.value], h.formato) }}</v-chip>
                          <template v-else>
                            {{ formatear(item[h.value], h.formato) }}
                          </template>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-tab-item>

              <!-- VENDEDORAS -->
              <v-tab-item>
                <v-card-text>
                  <v-alert type="info" text dense>
                    Contactos: prospectos atribuidos a Meta del día por vendedora asignada.
                    Inscripciones e ingresos: inscritos atribuidos del día por quien registró al alumno.
                    La conversión cruza ambos grupos del mismo día (no es la misma persona).
                  </v-alert>
                  <v-alert v-if="!crmDisponible" type="warning" text dense>
                    No hay reporte comercial (CRM) en el periodo: los datos por vendedora no están disponibles.
                  </v-alert>
                  <v-data-table v-else
                    :headers="headersVendedoras"
                    :items="vendedoras"
                    item-key="clave"
                    sort-by="prospectos"
                    sort-desc
                    dense
                    class="elevation-0"
                    :items-per-page="-1"
                    hide-default-footer
                    mobile-breakpoint="0"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td v-for="h in headersVendedoras" :key="h.value" :class="h.align === 'end' ? 'text-right' : ''">
                          {{ formatear(item[h.value], h.formato) }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-tab-item>

              <!-- PROSPECTOS -->
              <v-tab-item>
                <v-card-text>
                  <v-alert v-if="!prospectosDetalle" type="warning" text dense>
                    {{ textoSinDetalle }}
                  </v-alert>
                  <template v-else>
                    <v-row dense align="center">
                      <v-col cols="12" sm="3">
                        <v-select v-model="filtroCuenta" :items="opcionesCuenta" label="Cuenta como" filled dense hide-details></v-select>
                      </v-col>
                      <v-col cols="12" sm>
                        <v-text-field v-model="buscarProspecto" label="Buscar (nombre, teléfono, folio, anuncio, vendedora)" append-icon="mdi-magnify" clearable filled dense hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="auto">
                        <v-btn small tile color="green darken-1" dark class="mr-2" @click="exportarTabla(prospectosFiltrados, HEADERS_PROSPECTOS, 'prospectos')">
                          <v-icon left small>mdi-microsoft-excel</v-icon>
                          Excel
                        </v-btn>
                        <v-btn small tile color="blue-grey darken-1" dark @click="descargarArchivoJSON({ filtro: filtroCuenta, total: prospectosFiltrados.length, filas: prospectosFiltrados }, 'prospectos')">
                          <v-icon left small>mdi-code-json</v-icon>
                          JSON
                        </v-btn>
                      </v-col>
                    </v-row>
                    <div class="caption grey--text my-2">
                      {{ prospectosFiltrados.length }} de {{ prospectosDetalle.length }} prospectos creados en el periodo.
                      Cuentan como prospecto: {{ conteoCuenta.cuentan }} (nuevos {{ conteoCuenta.nuevo }}, rezagados {{ conteoCuenta.rezagado }}).
                      <span v-if="hayFiltros">Filtrados por el anuncio que trajo al contacto: los contactos sin anuncio Meta quedan fuera.</span>
                      Botón WhatsApp: conversación Twilio sin salir de esta vista.
                    </div>
                    <v-data-table
                      :headers="headersProspectosVista"
                      :items="prospectosFiltrados"
                      item-key="_clave"
                      :search="buscarProspecto"
                      dense
                      class="elevation-0"
                      :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
                      :items-per-page="25"
                      mobile-breakpoint="0"
                    >
                      <template v-slot:item="{ item }">
                        <tr :class="item.cuenta_como ? '' : 'grey--text'">
                          <td v-for="h in headersProspectosVista" :key="h.value" :class="h.align === 'end' ? 'text-right' : ''">
                            <v-btn
                              v-if="h.value === '_twilio'"
                              icon
                              small
                              color="green darken-1"
                              :disabled="!telefonoTwilioItem(item)"
                              :title="telefonoTwilioItem(item) ? 'Ver conversación Twilio' : 'Sin teléfono'"
                              @click.stop="abrirConversacionTwilio(item)"
                            >
                              <v-icon small>mdi-whatsapp</v-icon>
                            </v-btn>
                            <template v-else>
                              {{ formatear(item[h.value], h.formato) }}
                            </template>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </template>
                </v-card-text>
              </v-tab-item>

              <!-- CHECKLIST ci_meta (acciones Meta + tareas operativas) -->
              <v-tab-item>
                <v-card-text>
                  <ChecklistMeta :marca="escuela.toUpperCase()" />
                </v-card-text>
              </v-tab-item>

              <!-- LEYENDA -->
              <v-tab-item>
                <v-card-text>
                  <v-simple-table dense>
                    <tbody>
                      <tr v-for="l in leyenda" :key="l.indicador">
                        <td class="font-weight-bold" style="width: 220px">{{ l.indicador }}</td>
                        <td>{{ l.definicion }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                  <div class="caption grey--text mt-2">Versión de indicadores: {{ indicadores.version || '-' }}</div>
                </v-card-text>
              </v-tab-item>
            </v-tabs-items>
          </template>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogDetalle" max-width="1500" scrollable @click:outside="cerrarDetalle" @keydown.esc="cerrarDetalle">
      <v-card v-if="detalleActual">
        <v-card-title class="text-h6">
          {{ detalleActual.titulo }}
          <v-spacer></v-spacer>
          <v-btn small tile color="green darken-1" dark class="mr-2" :disabled="!filasDetalle" @click="exportarTabla(filasDetalle, headersDetalle, detalleActual.archivo)">
            <v-icon left small>mdi-microsoft-excel</v-icon>
            Excel
          </v-btn>
          <v-btn small tile color="blue-grey darken-1" dark class="mr-2" :disabled="!filasDetalle" @click="descargarJSONDetalle">
            <v-icon left small>mdi-code-json</v-icon>
            JSON
          </v-btn>
          <v-btn icon @click="cerrarDetalle"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <div class="body-2 mb-2">{{ detalleActual.descripcion }}</div>
          <v-alert v-if="!filasDetalle" type="warning" text dense>
            {{ textoSinDetalle }}
          </v-alert>
          <template v-else>
            <v-alert type="info" text dense>
              Filas que cuentan: <strong>{{ conteoDetalle }}</strong>.
              Valor de la tarjeta: <strong>{{ detalleActual.valorTarjeta }}</strong>.
              <span v-if="detalleActual.notaConteo"> {{ detalleActual.notaConteo }}</span>
              <span v-if="detalleActual.tabla === 'prospectos' || detalleActual.tabla === 'inscritos'">
                Usa el botón de WhatsApp para ver la conversación Twilio aquí mismo.
              </span>
            </v-alert>
            <v-text-field v-model="buscarDetalle" label="Buscar" append-icon="mdi-magnify" clearable filled dense hide-details class="mb-2"></v-text-field>
            <v-data-table
              :headers="headersDetalle"
              :items="filasDetalle"
              :item-key="detalleActual.llave"
              :search="buscarDetalle"
              dense
              class="elevation-0"
              :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
              :items-per-page="25"
              mobile-breakpoint="0"
            >
              <template v-slot:item="{ item }">
                <tr :class="item.cuenta === false ? 'grey--text' : ''">
                  <td v-for="h in headersDetalle" :key="h.value" :class="h.align === 'end' ? 'text-right' : ''">
                    <v-btn
                      v-if="h.value === '_twilio'"
                      icon
                      small
                      color="green darken-1"
                      :disabled="!telefonoTwilioItem(item)"
                      :title="telefonoTwilioItem(item) ? 'Ver conversación Twilio' : 'Sin teléfono'"
                      @click.stop="abrirConversacionTwilio(item)"
                    >
                      <v-icon small>mdi-whatsapp</v-icon>
                    </v-btn>
                    <template v-else>
                      {{ formatear(item[h.value], h.formato) }}
                    </template>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTwilio" max-width="920" scrollable @keydown.esc="cerrarConversacionTwilio">
      <v-card v-if="prospectoTwilio">
        <v-card-title class="subtitle-1">
          <v-icon left color="green darken-1">mdi-whatsapp</v-icon>
          Conversación · {{ tituloProspectoTwilio }}
          <v-spacer></v-spacer>
          <v-chip v-if="telefonoTwilioItem(prospectoTwilio)" x-small class="mr-2" color="green lighten-5">
            {{ telefonoTwilioItem(prospectoTwilio) }}
          </v-chip>
          <v-btn icon @click="cerrarConversacionTwilio"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <ConversacionTwilioLectura
            v-if="dialogTwilio && telefonoTwilioItem(prospectoTwilio)"
            :key="'twilio-' + telefonoTwilioItem(prospectoTwilio) + '-' + idEscuela"
            :escuela="idEscuela"
            :telefono="telefonoTwilioItem(prospectoTwilio)"
          />
          <v-alert v-else type="warning" text dense>Sin teléfono para cargar la conversación.</v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <ConsultorChat ref="consultor" :marca="escuela.toUpperCase()" :contexto="contextoConsultor" />
    <DetalleAnuncio ref="detalleAnuncio" :id-escuela="idEscuela" @ver-prospectos="verProspectosAnuncio" />

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
  import Alerta from '@/components/alertas/Alerta.vue'
  import carga from '@/components/alertas/carga.vue'
  import ConsultorChat from '@/components/centro-inteligencia/ConsultorChat.vue'
  import ChecklistMeta from '@/components/centro-inteligencia/ChecklistMeta.vue'
  import DetalleAnuncio from '@/components/centro-inteligencia/DetalleAnuncio.vue'
  import ConversacionTwilioLectura from '@/components/prospectos/ConversacionTwilioLectura.vue'
  import validarErrores from '@/mixins/validarErrores'
  import {
    indicadoresHomologados,
    formatoMoneda,
    formatoEntero,
    formatoPct,
    formatoRoas,
    fechaMonterrey,
    sumarDias,
    fechaHoraMonterrey,
  } from '@/helpers/meta-ads-definiciones'

  const XLSX = require('xlsx')

  const ESCUELAS = { inbi: 1, fast: 2 }
  const NOMBRE_RUTA = 'centroInteligenciaMeta'
  const ESCRIBIERON = ['nuevo', 'rezagado', 'reingreso']
  // Hoy es provisional; los rangos de varios días terminan ayer para comparar días completos.
  const ACCESOS_RAPIDOS = [
    { clave: 'hoy', texto: 'Hoy', hasta: 0, dias: 1 },
    { clave: 'ayer', texto: 'Ayer', hasta: -1, dias: 1 },
    { clave: '7', texto: '7 días', hasta: -1, dias: 7 },
    { clave: '14', texto: '14 días', hasta: -1, dias: 14 },
    { clave: '30', texto: '30 días', hasta: -1, dias: 30 },
  ]
  const FUENTES_ACTUALIZACION = [
    { clave: 'meta', nombre: 'Meta' },
    { clave: 'crm', nombre: 'CRM' },
    { clave: 'pagos', nombre: 'Pagos' },
  ]
  const TEXTO_SYNC = { EXITOSO: 'al día', PARCIAL: 'parcial', ERROR: 'con error', SIN_DATOS: 'sin datos' }
  const COLOR_SYNC = { EXITOSO: 'green lighten-4', PARCIAL: 'amber lighten-3', ERROR: 'red lighten-4', SIN_DATOS: 'grey lighten-2' }
  const MAX_DIAS_RANGO = 92
  const TEXTO_INTEGRIDAD = { COMPLETO: 'completos', PARCIAL: 'parciales', SIN_DATOS: 'sin datos' }
  const COLOR_INTEGRIDAD = { COMPLETO: 'green lighten-4', PARCIAL: 'amber lighten-3', SIN_DATOS: 'red darken-1' }
  const FUENTE_GASTO = {
    ads_insights: 'histórico diario de Meta',
    mixta: 'Meta y reportes del Analyzer',
    meta_reportes: 'reportes del Analyzer',
    sin_datos: 'sin datos',
  }
  const CAMPOS_CRM = ['prospectos', 'prospectos_nuevos', 'rezagados', 'registros_completos', 'nuevos_completos',
    'prospectos_google', 'prospectos_sucursal', 'registros_completados_periodo']
  const CAMPOS_PAGOS = ['inscritos', 'ingresos_primer_pago', 'inscripciones_totales', 'primeros_pagos_totales']
  const COSTOS_COMERCIALES = ['costo_por_nuevo_completo', 'costo_por_registro_completo', 'costo_por_prospecto', 'costo_por_inscrito', 'roas']

  const COL_TWILIO = { text: 'Chat', value: '_twilio', sortable: false, width: '56px' }

  const HEADERS_PROSPECTOS = [
    { text: 'Día de datos', value: 'fecha_datos', formato: 'texto' },
    { text: 'Folio', value: 'folio', formato: 'texto' },
    { text: 'ID', value: 'idprospectos', formato: 'texto' },
    { text: 'Nombre', value: 'nombre', formato: 'texto' },
    { text: 'Teléfono', value: 'tel10', formato: 'texto' },
    { text: 'Creado', value: 'fecha_creacion', formato: 'texto' },
    { text: 'Sucursal interés', value: 'sucursal_interes', formato: 'texto' },
    { text: 'Vendedora', value: 'vendedora', formato: 'texto' },
    { text: 'Clasificación', value: 'clasificacion', formato: 'texto' },
    { text: 'Seguimiento', value: 'seguimiento_vendedora', formato: 'seguimiento' },
    { text: 'Completo', value: 'registro_completo', formato: 'bool' },
    { text: 'Fuente completo', value: 'fuente_completo', formato: 'texto' },
    { text: 'Fecha inscripción', value: 'fecha_inscripcion', formato: 'texto' },
    { text: 'Inscripción (cohorte)', value: 'inscripcion_cohorte', formato: 'cohorte' },
    { text: 'Matrícula inscripción', value: 'matricula_inscripcion', formato: 'texto' },
    { text: 'Ad ID', value: 'ad_id', formato: 'texto' },
    { text: 'Anuncio', value: 'ad_name', formato: 'texto' },
    { text: 'Campaña', value: 'campaign_name', formato: 'texto' },
    { text: 'Conjunto', value: 'adset_name', formato: 'texto' },
    { text: 'Línea', value: 'linea_meta', formato: 'texto' },
    { text: 'Primer mensaje del día', value: 'fecha_primer_entrante', formato: 'texto' },
    { text: 'Mensaje previo', value: 'ultimo_entrante_previo', formato: 'texto' },
    { text: 'Días sin escribir', value: 'dias_sin_escribir', formato: 'entero', align: 'end' },
    { text: 'Cuenta como', value: 'cuenta_como', formato: 'texto' },
    { text: 'Motivo si no cuenta', value: 'motivo_no_cuenta', formato: 'texto' },
    { text: 'Inscrito ese día', value: 'inscrito_hoy', formato: 'bool' },
  ]

  const HEADERS_INSCRITOS = [
    { text: 'Día de datos', value: 'fecha_datos', formato: 'texto' },
    { text: 'ID prospecto', value: 'id_prospecto', formato: 'texto' },
    { text: 'Matrícula', value: 'matricula', formato: 'texto' },
    { text: 'Fecha inscripción', value: 'fecha_inscripcion', formato: 'texto' },
    { text: 'Primer pago', value: 'primer_pago', formato: 'moneda', align: 'end' },
    { text: 'Estado de pago', value: 'estado_pago', formato: 'texto' },
    { text: 'Sucursal', value: 'sucursal', formato: 'texto' },
    { text: 'Registró (vendedora)', value: 'vendedora_inscripcion', formato: 'texto' },
    { text: 'Atribución', value: 'atribucion', formato: 'texto' },
    { text: 'Motivo atribución', value: 'motivo_atribucion', formato: 'texto' },
    { text: 'Ad ID', value: 'ad_id', formato: 'texto' },
    { text: 'Anuncio', value: 'ad_name', formato: 'texto' },
    { text: 'Campaña', value: 'campaign_name', formato: 'texto' },
    { text: 'Cuenta', value: 'cuenta', formato: 'bool' },
  ]

  const DETALLES = {
    anuncios: {
      titulo: 'Anuncios del periodo',
      descripcion: 'Inversión y conversaciones por anuncio según Meta. Las conversaciones son chats iniciados, no personas.',
      tabla: 'anuncios', llave: 'ad_id', archivo: 'anuncios', campo: 'gasto', formato: 'moneda',
      notaConteo: 'La tarjeta de inversión es la suma del gasto de estas filas.',
    },
    nuevos: {
      titulo: 'Prospectos nuevos',
      descripcion: 'Escribieron por primera vez desde un anuncio Meta ese día.',
      tabla: 'prospectos', llave: '_clave', archivo: 'prospectos_nuevos', campo: 'prospectos_nuevos',
      filtro: (p) => p.cuenta_como === 'nuevo',
    },
    rezagados: {
      titulo: 'Rezagados',
      descripcion: 'Ya habían escrito y volvieron desde un anuncio después de 30 días o más sin escribir.',
      tabla: 'prospectos', llave: '_clave', archivo: 'rezagados', campo: 'rezagados',
      filtro: (p) => p.cuenta_como === 'rezagado',
    },
    completos: {
      titulo: 'Registros completos',
      descripcion: 'Prospectos con anuncio Meta que completaron su registro (incluye exalumnos que regresan).',
      tabla: 'prospectos', llave: '_clave', archivo: 'registros_completos', campo: 'registros_completos',
      filtro: (p) => !!p.ad_id && ESCRIBIERON.indexOf(p.clasificacion) !== -1 && p.registro_completo,
    },
    nuevos_completos: {
      titulo: 'Nuevos completos',
      descripcion: 'Prospectos nuevos que completaron su registro. Es el denominador del costo por nuevo completo.',
      tabla: 'prospectos', llave: '_clave', archivo: 'nuevos_completos', campo: 'nuevos_completos',
      filtro: (p) => p.cuenta_como === 'nuevo' && p.registro_completo,
    },
    inscritos: {
      titulo: 'Inscritos atribuidos (pagos Meta del periodo)',
      descripcion: 'Alumnos con alta en grupo y primer pago en el periodo, atribuidos a un anuncio Meta ≤ 90 días. No es la cohorte de Contactos: pudo haber contactado en otro periodo (incluso fuera de este rango).',
      tabla: 'inscritos', llave: '_clave', archivo: 'inscritos', campo: 'inscritos',
      notaConteo: 'En gris: inscritos sin anuncio Meta atribuible (no cuentan).',
    },
    inscritos_cohorte_periodo: {
      titulo: 'Inscritos en periodo (de contactos)',
      descripcion: 'De los contactos (nuevos + rezagados Meta) del periodo, quiénes tienen primer pago dentro del mismo periodo.',
      tabla: 'prospectos', llave: '_clave', archivo: 'inscritos_cohorte_periodo', campo: 'inscritos_cohorte_periodo',
      filtro: (p) => !!p.cuenta_como && p.inscripcion_cohorte === 'en_periodo',
      notaConteo: 'Cohorte de Contactos; no es la misma población que Inscripciones Meta.',
    },
  }

  /** Detalle drill-down por Contactos / Completos / Inscritos (y Nuevos / Rezagados en Anuncios). */
  const DETALLE_CRM = {
    prospectos: {
      titulo: 'Contactos',
      descripcion: 'Prospectos nuevos y rezagados que escribieron en el periodo desde un anuncio Meta. El día es el del primer mensaje entrante (no el de inscripción).',
      tabla: 'prospectos', llave: '_clave', archivo: 'contactos',
      filtro: (p) => !!p.cuenta_como,
      notaConteo: 'Contactos = nuevos + rezagados que cuentan en el indicador.',
    },
    prospectos_nuevos: {
      titulo: 'Prospectos nuevos',
      descripcion: 'Escribieron por primera vez desde un anuncio Meta ese día.',
      tabla: 'prospectos', llave: '_clave', archivo: 'prospectos_nuevos',
      filtro: (p) => p.cuenta_como === 'nuevo',
    },
    rezagados: {
      titulo: 'Rezagados',
      descripcion: 'Ya habían escrito y volvieron desde un anuncio Meta tras 30 días o más sin escribir.',
      tabla: 'prospectos', llave: '_clave', archivo: 'rezagados',
      filtro: (p) => p.cuenta_como === 'rezagado',
    },
    registros_completos: {
      titulo: 'Registros completos',
      descripcion: 'Prospectos con anuncio Meta (nuevo, rezagado o reingreso) que completaron su registro en CRM.',
      tabla: 'prospectos', llave: '_clave', archivo: 'registros_completos',
      filtro: (p) => !!p.ad_id && ESCRIBIERON.indexOf(p.clasificacion) !== -1 && p.registro_completo,
      notaConteo: 'Incluye reingresos; no es solo el subconjunto de Contactos.',
    },
    inscritos: {
      titulo: 'Inscritos atribuidos (pagos Meta del periodo)',
      descripcion: 'Alumnos con alta en grupo y primer pago en el periodo, atribuidos a un anuncio Meta ≤ 90 días. No es la cohorte de Contactos: pudo haber contactado en otro periodo (incluso fuera de este rango).',
      tabla: 'inscritos', llave: '_clave', archivo: 'inscritos',
      notaConteo: 'No es la misma cohorte de Contactos: el inscrito pudo haber escrito en otro periodo.',
    },
    inscritos_cohorte_periodo: {
      titulo: 'Inscritos en periodo (de contactos)',
      descripcion: 'De los contactos (nuevos + rezagados Meta) del periodo, quiénes tienen primer pago con fecha dentro del mismo periodo. Cohorte de contactos, no la columna Inscritos de atribución Meta.',
      tabla: 'prospectos', llave: '_clave', archivo: 'inscritos_cohorte_periodo',
      filtro: (p) => !!p.cuenta_como && p.inscripcion_cohorte === 'en_periodo',
      notaConteo: 'Denominador implícito: Contactos del alcance (estratega/anuncio).',
    },
  }

  const COLUMNAS_METRICAS = [
    { text: 'Gasto', value: 'gasto', formato: 'moneda', align: 'end' },
    { text: 'Conversaciones', value: 'conversaciones_meta', formato: 'entero', align: 'end' },
    { text: 'Costo / conversación', value: 'costo_por_conversacion', formato: 'moneda', align: 'end' },
    { text: 'Nuevos', value: 'prospectos_nuevos', formato: 'entero', align: 'end' },
    { text: 'Contestó', value: 'contesto', formato: 'entero', align: 'end' },
    { text: 'No contestó', value: 'no_contesto', formato: 'entero', align: 'end' },
    { text: 'No contactado', value: 'no_contactado', formato: 'entero', align: 'end' },
    { text: 'Rezagados', value: 'rezagados', formato: 'entero', align: 'end' },
    { text: 'Inscritos en periodo (de contactos)', value: 'inscritos_cohorte_periodo', formato: 'entero', align: 'end', ayuda: 'De los Contactos del periodo (nuevos+rezagados Meta): cuántos tienen primer pago dentro del mismo rango.' },
    { text: 'Completos', value: 'registros_completos', formato: 'entero', align: 'end' },
    { text: 'Nuevos completos', value: 'nuevos_completos', formato: 'entero', align: 'end' },
    { text: 'Costo / nuevo completo', value: 'costo_por_nuevo_completo', formato: 'moneda', align: 'end' },
    { text: 'Inscritos atribuidos (pagos Meta del periodo)', value: 'inscritos', formato: 'entero', align: 'end', ayuda: 'Pagos del periodo atribuidos a un anuncio Meta ≤ 90 días. No es la cohorte de Contactos: el alumno pudo haber contactado en otro periodo (incluso fuera de este rango).' },
    { text: 'Costo / inscripción', value: 'costo_por_inscrito', formato: 'moneda', align: 'end' },
    { text: 'Ingresos', value: 'ingresos_primer_pago', formato: 'moneda', align: 'end' },
  ]

  const KPIS_ESTRATEGA = [
    { titulo: 'Inversión', campo: 'gasto', formato: 'moneda', neutral: true },
    { titulo: 'Contactos', campo: 'prospectos', formato: 'entero' },
    {
      titulo: 'Inscritos en periodo (de contactos)', campo: 'inscritos_cohorte_periodo', formato: 'entero',
      ayuda: 'De los Contactos del periodo: cuántos tienen primer pago dentro del mismo rango.',
    },
    { titulo: 'Costo por contacto', campo: 'costo_por_prospecto', formato: 'moneda', invertir: true },
    { titulo: 'Completos', campo: 'registros_completos', formato: 'entero' },
    { titulo: 'Costo por completo', campo: 'costo_por_registro_completo', formato: 'moneda', invertir: true },
    {
      titulo: 'Inscritos atribuidos (pagos Meta del periodo)', campo: 'inscritos', formato: 'entero',
      ayuda: 'Pagos del periodo atribuidos a Meta ≤ 90 días. Otra población: pudo contactar en otro periodo (incluso fuera de este rango).',
    },
    { titulo: 'Costo por inscripción', campo: 'costo_por_inscrito', formato: 'moneda', invertir: true },
    { titulo: 'Ingresos', campo: 'ingresos_primer_pago', formato: 'moneda' },
    { titulo: 'ROAS', campo: 'roas', formato: 'roas' },
  ]

  const COLUMNAS_ENTREGA = [
    { text: 'Impresiones', value: 'impresiones', formato: 'entero', align: 'end' },
    { text: 'CTR', value: 'ctr', formato: 'pct', align: 'end' },
    { text: 'CPM', value: 'cpm', formato: 'moneda', align: 'end' },
  ]

  const COLUMNAS_VARIACION = [
    { text: 'Var. inversión', value: 'var_gasto_pct', formato: 'var', align: 'end', neutral: true },
    { text: 'Var. nuevos completos', value: 'var_nuevos_completos_pct', formato: 'var', align: 'end' },
    { text: 'Var. costo / nuevo completo', value: 'var_costo_por_nuevo_completo_pct', formato: 'var', align: 'end', invertir: true },
  ]

  function variacionPct (actual, anterior) {
    const a = Number(actual)
    const b = Number(anterior)
    if (actual === null || actual === undefined || anterior === null || anterior === undefined || !b) return null
    return Math.round(((a - b) / Math.abs(b)) * 10000) / 100
  }

  function conVariacion (filas, anteriores, llave) {
    const previo = {}
    ;(anteriores || []).forEach((f) => { previo[f[llave]] = f })
    return filas.map((f) => {
      const p = previo[f[llave]] || {}
      return {
        ...f,
        var_gasto_pct: variacionPct(f.gasto, p.gasto),
        var_nuevos_completos_pct: variacionPct(f.nuevos_completos, p.nuevos_completos),
        var_costo_por_nuevo_completo_pct: variacionPct(f.costo_por_nuevo_completo, p.costo_por_nuevo_completo),
      }
    })
  }

  const CAMPOS_SUMA_ANUNCIO = ['gasto', 'conversaciones_meta', 'prospectos', 'prospectos_nuevos', 'contesto', 'no_contesto', 'no_contactado', 'rezagados', 'reingresos',
    'registros_completos', 'nuevos_completos', 'inscritos_cohorte_periodo', 'inscritos', 'ingresos_primer_pago']

  function costoONull (gasto, n) {
    return n > 0 ? Math.round((gasto / n) * 100) / 100 : null
  }

  /** Suma anuncios del panel y recalcula costos sobre el total (mismas fórmulas que el motor del panel). */
  function sumarAnuncios (filas, extra) {
    const t = { ...extra }
    CAMPOS_SUMA_ANUNCIO.forEach((k) => { t[k] = filas.reduce((s, f) => s + (Number(f[k]) || 0), 0) })
    t.gasto = Math.round(t.gasto * 100) / 100
    t.ingresos_primer_pago = Math.round(t.ingresos_primer_pago * 100) / 100
    t.costo_por_conversacion = costoONull(t.gasto, t.conversaciones_meta)
    t.costo_por_prospecto = costoONull(t.gasto, t.prospectos)
    t.costo_por_registro_completo = costoONull(t.gasto, t.registros_completos)
    t.costo_por_nuevo_completo = costoONull(t.gasto, t.nuevos_completos)
    t.costo_por_inscrito = costoONull(t.gasto, t.inscritos)
    const escribieron = t.prospectos + t.reingresos
    t.pct_registros_completos = escribieron > 0 ? Math.round((t.registros_completos / escribieron) * 10000) / 100 : null
    t.roas = t.gasto > 0 ? Math.round((t.ingresos_primer_pago / t.gasto) * 100) / 100 : null
    return t
  }

  /** Global del periodo más los totales comerciales del panel de hoy (calculados sobre el periodo completo). */
  function derivadosGlobal (ind) {
    const g = (ind && ind.global) || {}
    const porOrigen = g.prospectos_por_origen || null
    const ins = (ind && ind.inscripciones) || null
    const completos = g.completos || null
    return {
      ...g,
      pct_presupuesto_usado: g.presupuesto_diario > 0 && g.gasto != null ? Math.round((g.gasto / g.presupuesto_diario) * 1000) / 10 : null,
      prospectos_google: porOrigen ? porOrigen.GOOGLE || 0 : null,
      prospectos_sucursal: porOrigen ? porOrigen.SUCURSAL || 0 : null,
      registros_completados_periodo: completos ? completos.registros_completados_en_periodo : null,
      inscripciones_totales: ins ? ins.nuevas : null,
      primeros_pagos_totales: ins ? ins.primeros_pagos_nuevas : null,
    }
  }

  export default {
    components: { Alerta, carga, ConsultorChat, ChecklistMeta, DetalleAnuncio, ConversacionTwilioLectura },

    mixins: [validarErrores],

    data: () => ({
      fechaDesde: fechaMonterrey(0),
      fechaHasta: fechaMonterrey(0),
      fechaMaxima: fechaMonterrey(0),
      comparar: true,
      ACCESOS_RAPIDOS,
      TEXTO_SYNC,
      COLOR_SYNC,
      TEXTO_INTEGRIDAD,
      COLOR_INTEGRIDAD,
      conciliacion: null,
      conciliando: false,
      reporte: null,
      sinReporte: false,
      tab: 0,
      vistaAnuncios: 'anuncio',
      filtroSucursal: null,
      filtroProducto: null,
      filtroCiudad: null,
      filtroEstratega: null,
      filtroAnuncio: null,
      filtroCampania: null,
      buscarAnuncio: '',
      umbralConversaciones: 10,
      umbralPctCompletos: 20,
      HEADERS_PROSPECTOS,
      filtroCuenta: 'todos',
      buscarProspecto: '',
      opcionesCuenta: [
        { text: 'Todos', value: 'todos' },
        { text: 'Cuentan (nuevos + rezagados)', value: 'cuentan' },
        { text: 'Nuevos', value: 'nuevo' },
        { text: 'Rezagados', value: 'rezagado' },
        { text: 'No cuentan', value: 'no_cuentan' },
      ],
      dialogDetalle: false,
      detalleTipo: null,
      detalleSeguimiento: null,
      detalleCrm: null,
      buscarDetalle: '',
      dialogTwilio: false,
      prospectoTwilio: null,
      columnasInscritosAyuda: ['inscritos_cohorte_periodo', 'inscritos'],
      LABELS_SEGUIMIENTO: {
        contesto: 'Contestó',
        no_contesto: 'No contestó',
        no_contactado: 'No contactado',
      },

      headersSucursales: [
        { text: 'Sucursal', value: 'sucursal', formato: 'texto' },
        { text: 'Inversión', value: 'gasto', formato: 'moneda', align: 'end' },
        { text: 'Conversaciones', value: 'conversaciones_meta', formato: 'entero', align: 'end' },
        { text: 'Nuevos', value: 'prospectos_nuevos', formato: 'entero', align: 'end' },
        { text: 'Rezagados', value: 'rezagados', formato: 'entero', align: 'end' },
        { text: 'Inscritos en periodo (de contactos)', value: 'inscritos_cohorte_periodo', formato: 'entero', align: 'end', ayuda: 'De los Contactos del periodo: cuántos tienen primer pago dentro del mismo rango.' },
        { text: 'Completos', value: 'registros_completos', formato: 'entero', align: 'end' },
        { text: '% completos', value: 'pct_registros_completos', formato: 'pct', align: 'end' },
        { text: 'Costo / nuevo completo', value: 'costo_por_nuevo_completo', formato: 'moneda', align: 'end' },
        { text: 'Inscritos atribuidos (pagos Meta del periodo)', value: 'inscritos', formato: 'entero', align: 'end', ayuda: 'Pagos del periodo atribuidos a Meta ≤ 90 días. No es la cohorte de Contactos: pudo contactar en otro periodo (incluso fuera de este rango).' },
        { text: 'Costo / inscripción', value: 'costo_por_inscrito', formato: 'moneda', align: 'end' },
        { text: 'Ingresos', value: 'ingresos_primer_pago', formato: 'moneda', align: 'end' },
      ],

      headersVendedoras: [
        { text: 'Vendedora', value: 'vendedora', formato: 'texto' },
        { text: 'Contactos asignados', value: 'prospectos', formato: 'entero', align: 'end' },
        { text: 'Nuevos', value: 'prospectos_nuevos', formato: 'entero', align: 'end' },
        { text: 'Rezagados', value: 'rezagados', formato: 'entero', align: 'end' },
        { text: 'Completos recibidos', value: 'registros_completos', formato: 'entero', align: 'end' },
        { text: 'Inscripciones', value: 'inscritos', formato: 'entero', align: 'end' },
        { text: 'Conversión', value: 'tasa_conversion_pct', formato: 'pct', align: 'end' },
        { text: 'Ingresos', value: 'ingresos_primer_pago', formato: 'moneda', align: 'end' },
      ],

      leyenda: [
        { indicador: 'Inversión', definicion: 'Lo que Meta cobró en el periodo por los anuncios de la marca: suma diaria del histórico de Meta. Si falta algún día en ese histórico se usa la de los reportes del Analyzer.' },
        { indicador: 'Periodo anterior', definicion: 'Los mismos días inmediatamente antes del periodo consultado (18–24 oct se compara con 11–17 oct). La variación en verde es mejora; en costos, bajar es mejora.' },
        { indicador: 'Impresiones, CTR, CPM', definicion: 'Del histórico diario de Meta. CTR = clics entre impresiones; CPM = inversión por cada mil impresiones.' },
        { indicador: 'Conciliar con Meta', definicion: 'Consulta en vivo la inversión de la cuenta de Meta para el periodo y la compara contra lo guardado.' },
        { indicador: 'Conversaciones', definicion: 'Chats de WhatsApp que Meta reporta como iniciados. No son personas: una persona puede abrir varias.' },
        { indicador: 'Costo por conversación', definicion: 'Inversión entre conversaciones.' },
        { indicador: 'Prospecto nuevo', definicion: 'Persona (teléfono de 10 dígitos + marca) que escribe por primera vez desde un anuncio Meta ese día.' },
        { indicador: 'Rezagado', definicion: 'Persona que ya había escrito y vuelve después de 30 días o más sin escribir, desde un anuncio.' },
        { indicador: 'Registro completo', definicion: 'INBI: llenó la ficha de pre-registro o el bot le envió el contexto. FAST: quedó marcado como CONTACTO TWILIO COMPLETO.' },
        { indicador: 'Nuevo completo', definicion: 'Prospecto nuevo que además completó su registro ese día.' },
        { indicador: 'Costo por nuevo completo', definicion: 'Inversión entre nuevos completos.' },
        { indicador: 'Inscrito (atribución)', definicion: 'Alumno con alta en grupo y primer pago ese día, que llegó por un anuncio Meta en los últimos 90 días. No es la cohorte de Contactos del periodo.' },
        { indicador: 'Inscritos en periodo (de contactos)', definicion: 'De los Contactos del periodo (nuevos + rezagados Meta), cuántos tienen primer pago con fecha dentro del mismo periodo. Ejemplo: 74 contactos hoy → cuántos de esos 74 se inscribieron hoy.' },
        { indicador: 'Inscritos atribuidos (pagos Meta del periodo)', definicion: 'Pagos del periodo atribuidos a un anuncio Meta ≤ 90 días. Otra población que la cohorte de Contactos: el alumno pudo haber contactado en otro periodo (incluso fuera de este rango).' },
        { indicador: 'Costo por inscripción', definicion: 'Inversión del día entre inscritos del día (el inscrito pudo llegar por un anuncio de días anteriores).' },
        { indicador: 'Ingresos atribuidos', definicion: 'Suma del primer pago de los inscritos atribuidos a Meta.' },
        { indicador: 'ROAS', definicion: 'Ingresos atribuidos entre inversión. 2x = por cada peso invertido entraron 2 en primeros pagos.' },
        { indicador: '% completos', definicion: 'Registros completos entre personas que escribieron (nuevos, rezagados y exalumnos que regresan).' },
        { indicador: 'Desempeño de estrategas', definicion: 'Suma de las sucursales asignadas a cada estratega. Contactos = nuevos + rezagados Meta del periodo. Inscritos en periodo (de contactos) = conversión de esa cohorte dentro del rango. Inscritos atribuidos = pagos del periodo atribuidos a Meta (otra población).' },
        { indicador: 'Filtros y navegación', definicion: 'Sucursal, producto, ciudad y estratega filtran por el anuncio: Sucursales, Estrategas, Anuncios y Prospectos muestran solo lo que trajeron esos anuncios. Clic en una sucursal o estratega abre sus anuncios; en el detalle de un anuncio, "Ver prospectos" lista los contactos que trajo.' },
        { indicador: 'Conversión de vendedora', definicion: 'Inscripciones de la vendedora entre sus contactos asignados del día. Son grupos distintos: es una referencia.' },
        { indicador: 'Reconstruido', definicion: 'Día calculado después, con la inversión de Meta de ese día y los datos actuales del sistema. La vendedora es la asignada hoy (pudo cambiar) y el registro completo es el estado actual.' },
        { indicador: 'Sin dato / -', definicion: 'No hay base para calcularlo (por ejemplo, costo con 0 completos) o falta la fuente. Nunca se muestra como 0.' },
        { indicador: 'Datos completos / parciales / sin datos', definicion: 'Estado de cada día según sus fuentes: Meta (inversión), CRM (prospectos y completos) y pagos (inscripciones). Si falta el CRM, la inversión se sigue mostrando pero prospectos, inscritos, costos por completo e inscripción y ROAS quedan como no disponibles.' },
        { indicador: 'Fila roja', definicion: 'Anuncio con inversión igual o mayor al doble del costo por completo del día (o al gasto promedio si no hubo completos) y 0 completos.' },
        { indicador: 'Fila naranja', definicion: 'Anuncio con muchas conversaciones y menos del 20 % convertidas en registro completo.' },
      ],
    }),

    computed: {
      escuela () {
        const e = String(this.$route.params.escuela || '').toLowerCase()
        return ESCUELAS[e] ? e : 'inbi'
      },

      idEscuela () {
        return ESCUELAS[this.escuela]
      },

      indicadores () {
        return indicadoresHomologados(this.reporte)
      },

      anterior () {
        return (this.reporte && this.reporte.anterior) || null
      },

      integridad () {
        return (this.indicadores && this.indicadores.integridad) || null
      },

      coberturaCrm () {
        return this.integridad ? this.integridad.cobertura.crm : 'completo'
      },

      crmDisponible () {
        return this.coberturaCrm !== 'ninguno'
      },

      crmCompleto () {
        return this.coberturaCrm === 'completo'
      },

      diasIncompletos () {
        return this.integridad ? this.integridad.por_dia.filter((d) => d.estado !== 'COMPLETO') : []
      },

      textoFuenteGasto () {
        return FUENTE_GASTO[this.indicadores && this.indicadores.fuente_gasto] || '-'
      },

      textoSinDetalle () {
        if (!this.crmDisponible) return 'No hay reporte comercial (CRM) en el periodo: el detalle por prospecto no está disponible.'
        return 'Este reporte no trae el detalle por prospecto (se generó antes de agregarlo).'
      },

      anteriorIncompleto () {
        const a = this.anterior
        if (!a) return ''
        const partes = []
        const sinReporte = a.rango.dias - a.dias_con_datos
        if (sinReporte > 0) partes.push(`${sinReporte} día(s) sin reporte del Analyzer`)
        if (a.dias_sin_historico_meta.length) partes.push(`${a.dias_sin_historico_meta.length} día(s) sin histórico de Meta`)
        if (a.integridad && a.integridad.cobertura.pagos !== 'completo' && sinReporte <= 0) partes.push('pagos incompletos')
        return partes.join(', ')
      },

      accesoRapido () {
        const a = ACCESOS_RAPIDOS.find((x) =>
          sumarDias(this.fechaMaxima, x.hasta) === this.fechaHasta &&
          sumarDias(this.fechaHasta, -(x.dias - 1)) === this.fechaDesde)
        return a ? a.clave : null
      },

      actualizacion () {
        return (this.indicadores && this.indicadores.actualizacion) || null
      },

      fuentesActualizacion () {
        const act = this.actualizacion
        if (!act) return []
        return FUENTES_ACTUALIZACION.map((f) => {
          const s = act.fuentes[f.clave] || {}
          const hora = this.horaCorta(s.ultima_actualizacion)
          return {
            ...f,
            estado: s.estado,
            texto: `${f.nombre} ${hora ? 'actualizado ' + hora : 'sin datos'}`,
            detalle: s.estado === 'ERROR'
              ? `Falló la actualización${s.ultimo_intento ? ' de las ' + this.horaCorta(s.ultimo_intento) : ''}: ${s.error || 'sin detalle'}. Se muestra el último dato válido.`
              : s.ultimo_intento ? `Última sincronización: ${this.horaCorta(s.ultimo_intento)}` : '',
          }
        })
      },

      fuentesConError () {
        return this.fuentesActualizacion.filter((f) => f.estado === 'ERROR')
      },

      comparacionParcial () {
        return !!(this.actualizacion && this.actualizacion.provisional && this.anterior)
      },

      textoRango () {
        const r = this.indicadores && this.indicadores.rango
        if (!r) return '-'
        return r.desde === r.hasta ? `Datos del ${r.desde}` : `Del ${r.desde} al ${r.hasta} (${r.dias} días)`
      },

      global () {
        return (this.indicadores && this.indicadores.global) || {}
      },

      textoGeneracion () {
        const texto = fechaHoraMonterrey(this.indicadores && this.indicadores.generado_en)
        if (texto) return texto
        return this.reporte && this.reporte.date_report
          ? `${this.reporte.date_report} (hora no registrada)`
          : '-'
      },

      tarjetasDireccion () {
        const g = derivadosGlobal(this.indicadores)
        const ant = derivadosGlobal(this.anterior)
        const r = (this.indicadores && this.indicadores.rango) || {}
        const soloHoy = r.dias === 1 && r.hasta === fechaMonterrey(0)
        const sinOrigen = 'No disponible para este periodo (no es cero)'
        return [
          { clave: 'gasto', titulo: 'Inversión', campo: 'gasto', formato: 'moneda', neutral: true, detalle: 'anuncios' },
          {
            clave: 'pres', titulo: 'Presupuesto usado', campo: 'pct_presupuesto_usado', formato: 'pct', neutral: true,
            nota: g.presupuesto_diario == null ? '' : `de ${formatoMoneda(g.presupuesto_diario)} ${r.dias > 1 ? 'autorizados en el periodo' : 'diarios autorizados'}`,
            motivoNull: 'Sin presupuesto autorizado vigente',
          },
          { clave: 'conv', titulo: 'Conversaciones', campo: 'conversaciones_meta', formato: 'entero', detalle: 'anuncios' },
          { clave: 'cconv', titulo: 'Costo por conversación', campo: 'costo_por_conversacion', formato: 'moneda', invertir: true, detalle: 'anuncios' },
          { clave: 'nuevos', titulo: 'Prospectos nuevos Meta', campo: 'prospectos_nuevos', formato: 'entero', detalle: 'nuevos' },
          { clave: 'rez', titulo: 'Rezagados Meta', campo: 'rezagados', formato: 'entero', detalle: 'rezagados' },
          {
            clave: 'coh_en', titulo: 'Inscritos en periodo (de contactos)', campo: 'inscritos_cohorte_periodo', formato: 'entero',
            nota: 'Contactos del periodo → primer pago dentro del rango', detalle: 'inscritos_cohorte_periodo',
          },
          { clave: 'cprosp', titulo: 'Costo por prospecto', campo: 'costo_por_prospecto', formato: 'moneda', invertir: true, detalle: 'nuevos' },
          { clave: 'pgoogle', titulo: 'Prospectos Google', campo: 'prospectos_google', formato: 'entero', neutral: true, nota: 'sin anuncio Meta', motivoNull: sinOrigen },
          { clave: 'psuc', titulo: 'Prospectos Sucursal', campo: 'prospectos_sucursal', formato: 'entero', neutral: true, nota: 'sin anuncio Meta', motivoNull: sinOrigen },
          { clave: 'comp', titulo: 'Registros completos', campo: 'registros_completos', formato: 'entero', nota: this.notaPct(g.pct_registros_completos), detalle: 'completos' },
          { clave: 'ncomp', titulo: 'Nuevos completos Meta', campo: 'nuevos_completos', formato: 'entero', detalle: 'nuevos_completos' },
          { clave: 'cncomp', titulo: 'Costo por nuevo completo', campo: 'costo_por_nuevo_completo', formato: 'moneda', invertir: true, detalle: 'nuevos_completos' },
          {
            clave: 'compper', titulo: soloHoy ? 'Registros completados hoy' : 'Registros completados en el periodo',
            campo: 'registros_completados_periodo', formato: 'entero', nota: 'por fecha en que se completaron (todos los orígenes)',
            motivoNull: (g.completos && g.completos.nota) || sinOrigen,
          },
          {
            clave: 'instot', titulo: 'Inscripciones totales', campo: 'inscripciones_totales', formato: 'entero',
            nota: g.inscritos == null ? '' : `${formatoEntero(g.inscritos)} atribuidas a Meta`, motivoNull: sinOrigen, detalle: 'inscritos',
          },
          { clave: 'ins', titulo: 'Inscritos atribuidos (pagos Meta del periodo)', campo: 'inscritos', formato: 'entero', nota: 'pagos del periodo con Meta ≤ 90 días; pudo contactar fuera de este rango', detalle: 'inscritos' },
          { clave: 'cins', titulo: 'Costo por inscripción', campo: 'costo_por_inscrito', formato: 'moneda', invertir: true, detalle: 'inscritos' },
          {
            clave: 'pptot', titulo: 'Primeros pagos totales', campo: 'primeros_pagos_totales', formato: 'moneda',
            nota: g.ingresos_primer_pago == null ? '' : `${formatoMoneda(g.ingresos_primer_pago)} de Meta`, motivoNull: sinOrigen, detalle: 'inscritos',
          },
          { clave: 'ingr', titulo: 'Primeros pagos Meta', campo: 'ingresos_primer_pago', formato: 'moneda', detalle: 'inscritos' },
          { clave: 'roas', titulo: 'ROAS', campo: 'roas', formato: 'roas', detalle: 'inscritos' },
          { clave: 'impr', titulo: 'Impresiones', campo: 'impresiones', formato: 'entero', nota: g.ctr == null ? '' : `CTR ${formatoPct(g.ctr)} · CPM ${formatoMoneda(g.cpm)}`, detalle: 'anuncios' },
        ].map((t) => ({
          ...t,
          valor: this.formatear(g[t.campo], t.formato),
          motivo: this.motivoNoDisponible(t.campo, g[t.campo]) || (g[t.campo] == null && t.motivoNull ? t.motivoNull : ''),
          anterior: this.formatear(ant[t.campo], t.formato),
          variacion: variacionPct(g[t.campo], ant[t.campo]),
        }))
      },

      sucursales () {
        const filas = (this.indicadores && this.indicadores.por_sucursal) || []
        return this.anterior ? conVariacion(filas, this.anterior.por_sucursal, 'sucursal') : filas
      },

      hayFiltros () {
        return !!(this.filtroSucursal || this.filtroProducto || this.filtroCiudad || this.filtroEstratega || this.filtroAnuncio)
      },

      ciudadPorSucursal () {
        const out = {}
        this.anuncios.forEach((a) => {
          if (a.sucursal_gasto && a.ciudad_objetivo && !out[a.sucursal_gasto]) out[a.sucursal_gasto] = a.ciudad_objetivo
        })
        return out
      },

      sucursalesEstratega () {
        if (!this.filtroEstratega) return null
        const e = (this.estrategas || []).find((x) => x.clave === this.filtroEstratega)
        return e ? e.sucursales : []
      },

      anunciosFiltrados () {
        return this.anuncios.filter((a) => this.anuncioPasaFiltros(a))
      },

      anuncioPorId () {
        const out = {}
        this.anuncios.forEach((a) => { out[String(a.ad_id)] = a })
        return out
      },

      resumenFiltro () {
        const t = sumarAnuncios(this.anunciosFiltrados, { anuncios: this.anunciosFiltrados.length })
        if (!this.crmDisponible) {
          ;['prospectos', 'nuevos_completos', 'inscritos', 'ingresos_primer_pago', 'costo_por_nuevo_completo'].forEach((k) => { t[k] = null })
        }
        return t
      },

      sucursalesVista () {
        if (this.filtroProducto || this.filtroAnuncio) {
          const grupos = {}
          this.anunciosFiltrados.forEach((a) => {
            const k = a.sucursal_gasto || 'SIN SUCURSAL'
            if (!grupos[k]) grupos[k] = []
            grupos[k].push(a)
          })
          return Object.keys(grupos).map((k) => sumarAnuncios(grupos[k], { sucursal: k }))
        }
        const ests = this.sucursalesEstratega
        return this.sucursales.filter((s) =>
          (!this.filtroSucursal || s.sucursal === this.filtroSucursal) &&
          (!ests || ests.indexOf(s.sucursal) !== -1) &&
          (!this.filtroCiudad || this.ciudadPorSucursal[s.sucursal] === this.filtroCiudad))
      },

      estrategasVista () {
        return (this.estrategas || []).filter((e) =>
          (!this.filtroEstratega || e.clave === this.filtroEstratega) &&
          (!this.filtroSucursal || e.sucursales.indexOf(this.filtroSucursal) !== -1) &&
          (!this.filtroCiudad || e.sucursales.some((s) => this.ciudadPorSucursal[s] === this.filtroCiudad)))
      },

      opcionesProducto () {
        return [...new Set(this.anuncios.map((a) => a.producto_homologado).filter(Boolean))].sort()
      },

      opcionesCiudad () {
        return [...new Set(this.anuncios.map((a) => a.ciudad_objetivo).filter(Boolean))].sort()
      },

      opcionesEstratega () {
        return (this.estrategas || []).map((e) => ({ text: e.estratega, value: e.clave }))
      },

      nombreFiltroAnuncio () {
        const a = this.filtroAnuncio ? this.anuncioPorId[this.filtroAnuncio] : null
        return a ? a.ad_name : this.filtroAnuncio
      },

      contextoConsultor () {
        const r = this.indicadores && this.indicadores.rango
        if (!r) return null
        const e = this.filtroEstratega ? (this.estrategas || []).find((x) => x.clave === this.filtroEstratega) : null
        return {
          desde: r.desde,
          hasta: r.hasta,
          filtros: {
            sucursal: this.filtroSucursal,
            producto: this.filtroProducto,
            ciudad: this.filtroCiudad,
            estratega: e ? `${e.estratega} (sucursales: ${e.sucursales.join(', ')})` : null,
            anuncio: this.filtroAnuncio ? `${this.filtroAnuncio} ${this.nombreFiltroAnuncio || ''}`.trim() : null,
          },
        }
      },

      estrategas () {
        const lista = this.indicadores && this.indicadores.por_estratega
        if (!Array.isArray(lista)) return null
        const previo = {}
        ;((this.anterior && this.anterior.por_estratega) || []).forEach((e) => { previo[e.id_usuario || 0] = e })
        return lista.map((e) => {
          const p = previo[e.id_usuario || 0] || {}
          const regreso = e.roas === null || e.roas === undefined ? '' : `Por cada $1 invertido regresaron ${formatoMoneda(e.roas)} en primeros pagos.`
          return {
            ...e,
            clave: e.id_usuario ? String(e.id_usuario) : 'sin-estratega',
            resumen: e.gasto > 0 && e.ingresos_primer_pago !== null
              ? `Invirtió ${formatoMoneda(e.gasto)} y regresó ${formatoMoneda(e.ingresos_primer_pago)}. ${regreso}`
              : '',
            kpis: KPIS_ESTRATEGA.map((k) => ({
              ...k,
              valor: this.formatear(e[k.campo], k.formato),
              motivo: this.motivoNoDisponible(k.campo, e[k.campo]),
              variacion: variacionPct(e[k.campo], p[k.campo]),
              ayuda: k.ayuda || '',
            })),
          }
        })
      },

      headersSucursalesVista () {
        return this.anterior ? this.headersSucursales.concat(COLUMNAS_VARIACION) : this.headersSucursales
      },

      headersEstrategasLista () {
        return [
          { text: 'Estratega', value: 'estratega', formato: 'texto' },
          { text: 'Sucursales', value: 'sucursales_texto', formato: 'texto', sortable: false },
        ].concat(KPIS_ESTRATEGA.map((k) => ({
          text: k.titulo,
          value: k.campo,
          formato: k.formato,
          align: 'end',
          invertir: !!k.invertir,
          neutral: !!k.neutral,
          ayuda: k.ayuda || '',
        })))
      },

      anuncios () {
        const filas = ((this.indicadores && this.indicadores.por_anuncio) || []).map((a) => ({
          ...a,
          ad_name: a.ad_name || `(sin gasto en el periodo) ${a.ad_id}`,
        }))
        return this.anterior ? conVariacion(filas, this.anterior.por_anuncio, 'ad_id') : filas
      },

      conjuntos () {
        return ((this.indicadores && this.indicadores.por_conjunto) || []).map((c) => ({
          ...c,
          clave: `${c.campaign_name}||${c.adset_name}`,
        }))
      },

      headersAnunciosVista () {
        const base = [
          { text: 'Campaña', value: 'campaign_name', formato: 'texto' },
          { text: 'Conjunto', value: 'adset_name', formato: 'texto' },
        ]
        if (this.vistaAnuncios !== 'anuncio') {
          return base.concat([{ text: 'Anuncios', value: 'anuncios', formato: 'entero', align: 'end' }], COLUMNAS_METRICAS)
        }
        return base.concat(
          [{ text: 'Anuncio', value: 'ad_name', formato: 'texto' }],
          COLUMNAS_METRICAS,
          COLUMNAS_ENTREGA,
          this.anterior ? COLUMNAS_VARIACION : []
        )
      },

      filasAnuncios () {
        if (this.vistaAnuncios === 'anuncio') {
          return this.anunciosFiltrados.filter((f) => !this.filtroCampania || f.campaign_name === this.filtroCampania)
        }
        const claves = {}
        this.anunciosFiltrados.forEach((a) => { claves[`${a.campaign_name}||${a.adset_name}`] = true })
        return this.conjuntos.filter((f) =>
          (!this.hayFiltros || claves[f.clave]) &&
          (!this.filtroCampania || f.campaign_name === this.filtroCampania)
        )
      },

      opcionesSucursal () {
        return [...new Set(this.anuncios.map((a) => a.sucursal_gasto).filter(Boolean))].sort()
      },

      opcionesCampania () {
        return [...new Set(this.anuncios.map((a) => a.campaign_name).filter(Boolean))].sort()
      },

      umbralGastoSinCompletos () {
        const costo = Number(this.global.costo_por_registro_completo)
        if (costo > 0) return Math.round(costo * 2 * 100) / 100
        const conGasto = this.anuncios.filter((a) => Number(a.gasto) > 0)
        if (!conGasto.length) return null
        const promedio = conGasto.reduce((s, a) => s + Number(a.gasto), 0) / conGasto.length
        return Math.round(promedio * 100) / 100
      },

      conteoAlertas () {
        const out = { gasto: 0, conversaciones: 0 }
        this.filasAnuncios.forEach((f) => {
          const c = this.claseAlerta(f)
          if (c === 'alerta-gasto') out.gasto++
          else if (c === 'alerta-conversaciones') out.conversaciones++
        })
        return out
      },

      vendedoras () {
        return ((this.indicadores && this.indicadores.por_vendedora) || []).map((v) => ({
          ...v,
          clave: v.id_usuario == null ? 'sin-asignar' : String(v.id_usuario),
        }))
      },

      prospectosDetalle () {
        return this.indicadores && Array.isArray(this.indicadores.prospectos_detalle)
          ? this.indicadores.prospectos_detalle.map((p, i) => ({ ...p, _clave: `${p.fecha_datos}|${p.idprospectos}|${i}` }))
          : null
      },

      inscritosDetalle () {
        return ((this.indicadores && this.indicadores.inscritos_detalle) || []).map((i, n) => ({
          ...i,
          _clave: `${i.fecha_datos}|${i.id_prospecto}|${i.matricula}|${n}`,
          cuenta: i.atribucion === 'parcial' && !!i.ad_id,
        }))
      },

      prospectosGlobal () {
        const lista = this.prospectosDetalle || []
        if (!this.hayFiltros) return lista
        return lista.filter((p) => {
          if (!p.ad_id) return false
          if (this.filtroAnuncio && String(p.ad_id) !== this.filtroAnuncio) return false
          const a = this.anuncioPorId[String(p.ad_id)]
          return !!a && this.anuncioPasaFiltros(a)
        })
      },

      prospectosFiltrados () {
        const f = this.filtroCuenta
        return this.prospectosGlobal.filter((p) => {
          if (f === 'cuentan') return !!p.cuenta_como
          if (f === 'nuevo' || f === 'rezagado') return p.cuenta_como === f
          if (f === 'no_cuentan') return !p.cuenta_como
          return true
        })
      },

      conteoCuenta () {
        const out = { cuentan: 0, nuevo: 0, rezagado: 0 }
        const lista = this.prospectosGlobal
        lista.forEach((p) => {
          if (!p.cuenta_como) return
          out.cuentan++
          if (out[p.cuenta_como] !== undefined) out[p.cuenta_como]++
        })
        return out
      },

      detalleActual () {
        if (this.detalleSeguimiento) {
          const s = this.detalleSeguimiento
          const filas = this.filasSeguimientoDetalle
          return {
            titulo: s.titulo,
            descripcion: 'Prospectos nuevos del anuncio/conjunto con ese estatus de seguimiento (Contestó / No contestó / No contactado).',
            tabla: 'prospectos',
            llave: '_clave',
            archivo: 'seguimiento_' + s.tipo,
            formato: 'entero',
            valorTarjeta: formatoEntero(filas ? filas.length : 0),
            notaConteo: 'Solo nuevos con anuncio Meta atribuido.',
          }
        }
        if (this.detalleCrm) {
          const d = this.detalleCrm
          const cfg = DETALLE_CRM[d.metrica] || {}
          return {
            titulo: d.titulo || cfg.titulo,
            descripcion: d.descripcion || cfg.descripcion,
            tabla: cfg.tabla || 'prospectos',
            llave: cfg.llave || '_clave',
            archivo: cfg.archivo || d.metrica,
            formato: 'entero',
            valorTarjeta: formatoEntero(d.valor),
            notaConteo: cfg.notaConteo || '',
          }
        }
        const cfg = DETALLES[this.detalleTipo]
        if (!cfg) return null
        const valor = this.global[cfg.campo]
        return {
          ...cfg,
          valorTarjeta: cfg.formato === 'moneda' ? formatoMoneda(valor) : formatoEntero(valor),
        }
      },

      filasSeguimientoDetalle () {
        const s = this.detalleSeguimiento
        if (!s || !this.prospectosDetalle) return null
        return this.prospectosDetalle
          .filter((p) => {
            if (p.cuenta_como !== 'nuevo') return false
            if ((p.seguimiento_vendedora || 'no_contactado') !== s.tipo) return false
            if (s.ad_id) return String(p.ad_id) === String(s.ad_id)
            const a = this.anuncioPorId[String(p.ad_id)]
            return !!(a && a.campaign_name === s.campaign_name && a.adset_name === s.adset_name)
          })
          .map((p, i) => ({ ...p, _clave: `${p.fecha_datos}|${p.idprospectos}|seg|${i}` }))
      },

      filasCrmDetalle () {
        const d = this.detalleCrm
        if (!d) return null
        const cfg = DETALLE_CRM[d.metrica]
        if (!cfg) return null
        if (cfg.tabla === 'inscritos') {
          return this.inscritosDetalle.filter((i) => i.cuenta && this.adEnAlcanceCrm(i.ad_id, d))
        }
        if (!this.prospectosDetalle) return null
        return this.prospectosDetalle
          .filter((p) => cfg.filtro(p) && this.adEnAlcanceCrm(p.ad_id, d))
          .map((p, i) => ({ ...p, _clave: `${p.fecha_datos}|${p.idprospectos}|crm|${i}` }))
      },

      headersProspectosVista () {
        return [COL_TWILIO].concat(HEADERS_PROSPECTOS)
      },

      /** Tel10 por id de prospecto (para inscritos sin teléfono en la fila). */
      telPorIdProspecto () {
        const out = {}
        ;(this.prospectosDetalle || []).forEach((p) => {
          if (p.idprospectos != null && p.tel10) out[String(p.idprospectos)] = p.tel10
        })
        return out
      },

      tituloProspectoTwilio () {
        const p = this.prospectoTwilio
        if (!p) return ''
        const partes = [p.folio, p.nombre || p.nombre_completo, p.matricula].filter(Boolean)
        return partes.length ? partes.join(' · ') : (p.idprospectos || p.id_prospecto || 'Prospecto')
      },

      headersDetalle () {
        const cfg = this.detalleActual
        if (!cfg) return []
        if (cfg.tabla === 'inscritos') return [COL_TWILIO].concat(HEADERS_INSCRITOS)
        if (cfg.tabla === 'anuncios') {
          return [
            { text: 'Campaña', value: 'campaign_name', formato: 'texto' },
            { text: 'Conjunto', value: 'adset_name', formato: 'texto' },
            { text: 'Anuncio', value: 'ad_name', formato: 'texto' },
            { text: 'Ad ID', value: 'ad_id', formato: 'texto' },
            { text: 'Sucursal (gasto)', value: 'sucursal_gasto', formato: 'texto' },
          ].concat(COLUMNAS_METRICAS)
        }
        return [COL_TWILIO].concat(HEADERS_PROSPECTOS)
      },

      filasDetalle () {
        if (this.detalleSeguimiento) return this.filasSeguimientoDetalle
        if (this.detalleCrm) return this.filasCrmDetalle
        const cfg = this.detalleActual
        if (!cfg) return []
        if (cfg.tabla === 'anuncios') return this.anuncios
        if (cfg.tabla === 'inscritos') return this.inscritosDetalle
        if (!this.prospectosDetalle) return null
        return this.prospectosDetalle.filter(cfg.filtro)
      },

      conteoDetalle () {
        const cfg = this.detalleActual
        const filas = this.filasDetalle || []
        if (!cfg) return '-'
        if (cfg.tabla === 'anuncios') return formatoMoneda(filas.reduce((s, a) => s + (Number(a.gasto) || 0), 0))
        if (cfg.tabla === 'inscritos') return formatoEntero(filas.filter((i) => i.cuenta).length)
        return formatoEntero(filas.length)
      },

      baseArchivo () {
        const r = (this.indicadores && this.indicadores.rango) || { desde: this.fechaDesde, hasta: this.fechaHasta }
        const periodo = r.desde === r.hasta ? r.desde : `${r.desde}_al_${r.hasta}`
        return `centro-inteligencia-meta_${this.escuela.toUpperCase()}_${periodo}`
      },
    },

    watch: {
      '$route.params.escuela' () {
        this.consultar()
      },
      dialogDetalle (abierto) {
        if (!abierto) {
          this.detalleSeguimiento = null
          this.detalleCrm = null
          this.detalleTipo = null
          this.buscarDetalle = ''
        }
      },
    },

    created () {
      if (this.$route.params.escuela !== this.escuela) {
        this.$router.replace({ name: NOMBRE_RUTA, params: { escuela: this.escuela } }).catch(() => {})
        return
      }
      this.consultar()
    },

    methods: {
      formatoMoneda,

      esColumnaSeguimiento (value) {
        return value === 'contesto' || value === 'no_contesto' || value === 'no_contactado'
      },

      esMetricaCrm (value) {
        return value === 'prospectos' || value === 'registros_completos' || value === 'inscritos' ||
          value === 'inscritos_cohorte_periodo'
      },

      textoSeguimiento (valor) {
        if (!valor) return 'No contactado'
        return this.LABELS_SEGUIMIENTO[valor] || valor
      },

      /** Conteo para chip de Contestó / No contestó / No contactado. */
      textoConteoSeguimiento (item, campo) {
        return formatoEntero(Number(item && item[campo]) || 0)
      },

      /** % sobre Nuevos del mismo anuncio/conjunto (debajo del chip, sin chip). */
      textoPctSeguimiento (item, campo) {
        const n = Number(item && item[campo]) || 0
        const base = Number(item && item.prospectos_nuevos) || 0
        const pct = base > 0 ? Math.round((n / base) * 1000) / 10 : 0
        const pctTxt = Number.isInteger(pct) ? String(pct) : pct.toFixed(1)
        return pctTxt + '%'
      },

      /** ¿El anuncio del prospecto/inscrito entra en el alcance del drill (estratega o anuncio/conjunto)? */
      adEnAlcanceCrm (adId, d) {
        if (!adId || !d) return false
        if (d.ad_id) return String(adId) === String(d.ad_id)
        const a = this.anuncioPorId[String(adId)]
        if (!a) return false
        if (d.campaign_name != null) {
          return a.campaign_name === d.campaign_name && a.adset_name === d.adset_name
        }
        if (d.sucursales && d.sucursales.length) {
          return d.sucursales.indexOf(a.sucursal_gasto) !== -1
        }
        return false
      },

      abrirDetalleCrm (metrica, alcance) {
        const cfg = DETALLE_CRM[metrica]
        if (!cfg) return
        if (cfg.tabla === 'inscritos') {
          if (!this.crmDisponible) {
            this.validarError(this.textoSinDetalle)
            return
          }
        } else if (!this.prospectosDetalle) {
          this.validarError(this.textoSinDetalle)
          return
        }
        this.detalleTipo = null
        this.detalleSeguimiento = null
        this.detalleCrm = {
          metrica,
          valor: alcance.valor,
          titulo: (cfg.titulo || metrica) + ' · ' + (alcance.nombre || ''),
          descripcion: cfg.descripcion,
          ad_id: alcance.ad_id || null,
          campaign_name: alcance.campaign_name || null,
          adset_name: alcance.adset_name || null,
          sucursales: alcance.sucursales || null,
        }
        this.buscarDetalle = ''
        this.dialogDetalle = true
      },

      abrirDetalleCrmEstratega (item, metrica) {
        if (!item || !this.esMetricaCrm(metrica)) return
        this.abrirDetalleCrm(metrica, {
          nombre: item.estratega,
          valor: item[metrica],
          sucursales: item.sucursales || [],
        })
      },

      abrirDetalleCrmAnuncio (item, metrica) {
        if (!item || !DETALLE_CRM[metrica]) return
        const nombre = item.ad_name || item.adset_name || item.campaign_name || 'Anuncio'
        this.abrirDetalleCrm(metrica, {
          nombre,
          valor: item[metrica],
          ad_id: item.ad_id || null,
          campaign_name: item.campaign_name || null,
          adset_name: item.adset_name || null,
        })
      },

      telefonoTwilioItem (item) {
        if (!item) return ''
        const directo = String(item.tel10 || item.telefono || item.twilio || item.movil || '').replace(/\D/g, '')
        if (directo.length >= 10) return directo.slice(-10)
        const id = item.idprospectos != null ? item.idprospectos : item.id_prospecto
        const porId = id != null ? this.telPorIdProspecto[String(id)] : ''
        return porId ? String(porId).replace(/\D/g, '').slice(-10) : ''
      },

      abrirConversacionTwilio (item) {
        if (!this.telefonoTwilioItem(item)) {
          this.validarError('Este registro no tiene teléfono para abrir Twilio')
          return
        }
        this.prospectoTwilio = item
        this.dialogTwilio = true
      },

      cerrarConversacionTwilio () {
        this.dialogTwilio = false
        this.prospectoTwilio = null
      },

      formatear (valor, formato) {
        if (formato === 'moneda') return formatoMoneda(valor)
        if (formato === 'entero') return formatoEntero(valor)
        if (formato === 'pct') return formatoPct(valor)
        if (formato === 'roas') return formatoRoas(valor)
        if (formato === 'seguimiento') return this.textoSeguimiento(valor)
        if (formato === 'cohorte') {
          if (valor === 'en_periodo') return 'En periodo'
          if (valor === 'fuera_periodo') return 'Fuera del periodo'
          return valor ? String(valor) : 'Sin inscripción'
        }
        if (formato === 'var') {
          if (valor === null || valor === undefined) return '-'
          return `${valor > 0 ? '+' : ''}${Number(valor).toLocaleString('es-MX', { maximumFractionDigits: 1 })} %`
        }
        if (formato === 'bool') return valor === true ? 'Sí' : valor === false ? 'No' : '-'
        return valor === null || valor === undefined || valor === '' ? '-' : valor
      },

      claseVariacion (valor, invertir) {
        if (!valor) return 'grey--text'
        const mejora = invertir ? valor < 0 : valor > 0
        return mejora ? 'green--text text--darken-2' : 'red--text text--darken-2'
      },

      celdaClase (h, item) {
        const clases = h.align === 'end' ? ['text-right'] : []
        if (h.formato === 'var' && !h.neutral) clases.push(this.claseVariacion(item[h.value], h.invertir))
        return clases
      },

      rangoRapido (acceso) {
        this.fechaMaxima = fechaMonterrey(0)
        this.fechaHasta = sumarDias(this.fechaMaxima, acceso.hasta)
        this.fechaDesde = sumarDias(this.fechaHasta, -(acceso.dias - 1))
        this.consultar()
      },

      horaCorta (texto) {
        if (!texto) return ''
        const dia = String(texto).slice(0, 10)
        const hora = String(texto).slice(11, 16)
        return dia === fechaMonterrey(0) ? hora : `${dia.slice(8, 10)}/${dia.slice(5, 7)} ${hora}`
      },

      abrirAnuncio (item) {
        if (this.vistaAnuncios !== 'anuncio' || !item.ad_id) return
        const r = this.indicadores.rango
        this.$refs.detalleAnuncio.abrir(item, { desde: r.desde, hasta: r.hasta, comparar: this.comparar })
      },

      anuncioPasaFiltros (a) {
        const ests = this.sucursalesEstratega
        return (!this.filtroSucursal || a.sucursal_gasto === this.filtroSucursal) &&
          (!this.filtroProducto || a.producto_homologado === this.filtroProducto) &&
          (!this.filtroCiudad || a.ciudad_objetivo === this.filtroCiudad) &&
          (!ests || ests.indexOf(a.sucursal_gasto) !== -1) &&
          (!this.filtroAnuncio || String(a.ad_id) === this.filtroAnuncio)
      },

      limpiarFiltros () {
        this.filtroSucursal = null
        this.filtroProducto = null
        this.filtroCiudad = null
        this.filtroEstratega = null
        this.filtroAnuncio = null
        this.filtroCampania = null
      },

      verSucursal (item) {
        this.filtroSucursal = item.sucursal
        this.filtroAnuncio = null
        this.vistaAnuncios = 'anuncio'
        this.tab = 4
      },

      verEstratega (e) {
        this.filtroEstratega = e.clave
        this.filtroSucursal = null
        this.filtroAnuncio = null
        this.vistaAnuncios = 'anuncio'
        this.tab = 4
      },

      verProspectosAnuncio (anuncio) {
        if (!anuncio || !anuncio.ad_id) return
        this.filtroAnuncio = String(anuncio.ad_id)
        this.filtroCuenta = 'todos'
        this.buscarProspecto = ''
        this.tab = 6
      },

      conciliar () {
        const r = this.indicadores.rango
        this.conciliando = true
        return this.$http.post('api/meta/conciliacion/' + this.idEscuela, { desde: r.desde, hasta: r.hasta })
          .then((response) => { this.conciliacion = response.data })
          .catch((error) => { this.validarError(error) })
          .finally(() => { this.conciliando = false })
      },

      abrirDetalle (tipo) {
        this.detalleSeguimiento = null
        this.detalleCrm = null
        this.detalleTipo = tipo
        this.buscarDetalle = ''
        this.dialogDetalle = true
      },

      cerrarDetalle () {
        this.dialogDetalle = false
        this.detalleSeguimiento = null
        this.detalleCrm = null
        this.detalleTipo = null
        this.buscarDetalle = ''
      },

      abrirSeguimientoAnuncio (item, tipo) {
        if (!item || !this.esColumnaSeguimiento(tipo)) return
        if (!this.prospectosDetalle) {
          this.validarError('No hay detalle de prospectos en este periodo')
          return
        }
        const label = this.LABELS_SEGUIMIENTO[tipo] || tipo
        const nombre = item.ad_name || item.adset_name || item.campaign_name || 'Anuncio'
        this.detalleTipo = null
        this.detalleCrm = null
        this.detalleSeguimiento = {
          tipo: tipo,
          ad_id: item.ad_id || null,
          campaign_name: item.campaign_name || null,
          adset_name: item.adset_name || null,
          titulo: label + ' · ' + nombre,
        }
        this.buscarDetalle = ''
        this.dialogDetalle = true
      },

      valorExcel (valor, formato) {
        if (valor === null || valor === undefined) return ''
        if (formato === 'bool') return valor ? 'Sí' : 'No'
        return valor
      },

      hojaDesde (filas, headers) {
        return XLSX.utils.json_to_sheet((filas || []).map((f) => {
          const row = {}
          headers.forEach((h) => { row[h.text] = this.valorExcel(f[h.value], h.formato) })
          return row
        }))
      },

      exportarTabla (filas, headers, nombre) {
        const libro = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(libro, this.hojaDesde(filas, headers), String(nombre).slice(0, 31))
        XLSX.writeFile(libro, `${this.baseArchivo}_${nombre}.xlsx`)
      },

      descargarExcel () {
        const ind = this.indicadores
        const g = this.global
        const resumen = [
          ['Marca', this.escuela.toUpperCase()],
          ['Desde', ind.rango.desde],
          ['Hasta', ind.rango.hasta],
          ['Días', ind.rango.dias],
          ['Días sin reporte del Analyzer', ind.dias_sin_reporte.join(', ')],
          ['Días sin histórico de Meta', ind.dias_sin_historico_meta.join(', ')],
          ['Estado de los datos', this.integridad ? TEXTO_INTEGRIDAD[this.integridad.estado] : ''],
          ['Advertencias', this.integridad ? this.integridad.advertencias.join(' ') : ''],
          ['Días incompletos', this.diasIncompletos.map((d) => `${d.fecha} (falta ${d.faltan.join(', ')})`).join('; ')],
          ['Fuente de la inversión', this.textoFuenteGasto],
          ['Generado', this.textoGeneracion],
          ['Reconstruido', ind.reconstruido ? 'Sí' : 'No'],
          ['Versión', ind.version],
          ['Inversión', g.gasto],
          ['Impresiones', g.impresiones],
          ['CTR', g.ctr],
          ['CPC (enlace)', g.cpc],
          ['CPM', g.cpm],
          ['Conversaciones', g.conversaciones_meta],
          ['Costo por conversación', g.costo_por_conversacion],
          ['Prospectos (nuevos + rezagados)', g.prospectos],
          ['Prospectos nuevos', g.prospectos_nuevos],
          ['Rezagados', g.rezagados],
          ['Reingresos (exalumnos)', g.reingresos],
          ['Continuaciones', g.continuaciones],
          ['Sin anuncio Meta', g.prospectos_sin_anuncio],
          ['Sin mensaje entrante', g.sin_mensaje_entrante],
          ['Registros completos', g.registros_completos],
          ['% completos', g.pct_registros_completos],
          ['Nuevos completos', g.nuevos_completos],
          ['Costo por nuevo completo', g.costo_por_nuevo_completo],
          ['Inscritos atribuidos', g.inscritos],
          ['Inscritos no atribuibles', g.inscritos_no_atribuibles],
          ['Costo por inscripción', g.costo_por_inscrito],
          ['Ingresos atribuidos', g.ingresos_primer_pago],
          ['ROAS', g.roas],
          ['Presupuesto (suma de topes diarios)', g.presupuesto_diario],
        ].concat(this.anterior ? [
          ['Periodo anterior', `${this.anterior.rango.desde} al ${this.anterior.rango.hasta}`],
          ['Inversión anterior', this.anterior.global.gasto],
          ['Nuevos completos anterior', this.anterior.global.nuevos_completos],
          ['Costo por nuevo completo anterior', this.anterior.global.costo_por_nuevo_completo],
          ['Inscritos anterior', this.anterior.global.inscritos],
        ] : []).map(([indicador, valor]) => ({ Indicador: indicador, Valor: valor === null || valor === undefined ? '' : valor }))

        const headersAnuncio = [
          { text: 'Campaña', value: 'campaign_name' },
          { text: 'Conjunto', value: 'adset_name' },
          { text: 'Anuncio', value: 'ad_name' },
          { text: 'Ad ID', value: 'ad_id' },
          { text: 'Sucursal (gasto)', value: 'sucursal_gasto' },
        ].concat(COLUMNAS_METRICAS)
        const headersConjunto = [
          { text: 'Campaña', value: 'campaign_name' },
          { text: 'Conjunto', value: 'adset_name' },
          { text: 'Sucursal (gasto)', value: 'sucursal_gasto' },
          { text: 'Anuncios', value: 'anuncios' },
        ].concat(COLUMNAS_METRICAS)

        const libro = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(libro, XLSX.utils.json_to_sheet(resumen), 'Resumen')
        XLSX.utils.book_append_sheet(libro, this.hojaDesde(this.prospectosDetalle || [], HEADERS_PROSPECTOS), 'Prospectos')
        XLSX.utils.book_append_sheet(libro, this.hojaDesde(this.inscritosDetalle, HEADERS_INSCRITOS), 'Inscritos')
        XLSX.utils.book_append_sheet(libro, this.hojaDesde(this.anuncios, headersAnuncio), 'Anuncios')
        XLSX.utils.book_append_sheet(libro, this.hojaDesde(this.conjuntos, headersConjunto), 'Conjuntos')
        XLSX.utils.book_append_sheet(libro, this.hojaDesde(this.sucursales, this.headersSucursales), 'Sucursales')
        XLSX.utils.book_append_sheet(libro, this.hojaDesde(
          (this.estrategas || []).map((e) => ({ ...e, sucursales_texto: e.sucursales.join(', ') })),
          [{ text: 'Estratega', value: 'estratega' }, { text: 'Sucursales', value: 'sucursales_texto' }].concat(KPIS_ESTRATEGA.map((k) => ({ text: k.titulo, value: k.campo })))
        ), 'Estrategas')
        XLSX.utils.book_append_sheet(libro, this.hojaDesde(this.vendedoras, this.headersVendedoras), 'Vendedoras')
        XLSX.utils.book_append_sheet(libro, XLSX.utils.json_to_sheet(this.leyenda.map((l) => ({ Indicador: l.indicador, Definición: l.definicion }))), 'Leyenda')
        XLSX.writeFile(libro, `${this.baseArchivo}.xlsx`)
      },

      descargarJSON () {
        this.descargarArchivoJSON(this.reporte, '')
      },

      descargarJSONDetalle () {
        const cfg = this.detalleActual
        const filas = this.filasDetalle || []
        this.descargarArchivoJSON({
          marca: this.escuela.toUpperCase(),
          rango: this.indicadores.rango,
          generado_en: this.indicadores.generado_en,
          indicador: cfg.titulo,
          descripcion: cfg.descripcion,
          valor_tarjeta: this.global[cfg.campo],
          conteo_detalle: cfg.tabla === 'inscritos' ? filas.filter((i) => i.cuenta).length : filas.length,
          filas,
        }, cfg.archivo)
      },

      descargarArchivoJSON (datos, nombre) {
        const blob = new Blob([JSON.stringify(datos, null, 2)], { type: 'application/json' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = nombre ? `${this.baseArchivo}_${nombre}.json` : `${this.baseArchivo}.json`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      },

      notaPct (pct) {
        const texto = formatoPct(pct)
        return pct === null || pct === undefined ? '' : `${texto} de quienes escribieron`
      },

      motivoNoDisponible (campo, valor) {
        if (valor !== null && valor !== undefined) return ''
        const pagos = this.integridad ? this.integridad.cobertura.pagos : 'completo'
        if (CAMPOS_CRM.indexOf(campo) !== -1 && !this.crmDisponible) return 'Sin reporte comercial (no es cero)'
        if (CAMPOS_PAGOS.indexOf(campo) !== -1 && pagos === 'ninguno') return 'Sin datos de pagos (no es cero)'
        if (COSTOS_COMERCIALES.indexOf(campo) === -1) return ''
        if (!this.crmDisponible) return 'No calculable: falta el CRM'
        if (!this.crmCompleto) return 'No calculable: faltan días del CRM'
        if (pagos !== 'completo' && (campo === 'costo_por_inscrito' || campo === 'roas')) return 'No calculable: faltan días de pagos'
        return ''
      },

      claseAlerta (fila) {
        if (!this.crmCompleto || fila.registros_completos === null || fila.registros_completos === undefined) return ''
        const gasto = Number(fila.gasto) || 0
        const completos = Number(fila.registros_completos) || 0
        const conversaciones = Number(fila.conversaciones_meta) || 0
        const umbral = this.umbralGastoSinCompletos
        if (umbral !== null && gasto > 0 && gasto >= umbral && completos === 0) return 'alerta-gasto'
        if (conversaciones >= this.umbralConversaciones && (completos / conversaciones) * 100 < this.umbralPctCompletos) {
          return 'alerta-conversaciones'
        }
        return ''
      },

      cambiarEscuela (valor) {
        if (!valor || valor === this.escuela) return
        this.$router.push({ name: NOMBRE_RUTA, params: { escuela: valor } }).catch(() => {})
      },

      validarRangoFechas () {
        if (!this.fechaDesde || !this.fechaHasta) return 'Selecciona las fechas desde y hasta'
        if (this.fechaDesde > this.fechaHasta) return 'La fecha desde no puede ser mayor que la fecha hasta'
        if (this.fechaHasta > this.fechaMaxima) return `La fecha hasta no puede ser posterior al ${this.fechaMaxima}`
        const dias = Math.round((new Date(`${this.fechaHasta}T12:00:00Z`) - new Date(`${this.fechaDesde}T12:00:00Z`)) / 86400000) + 1
        if (dias > MAX_DIAS_RANGO) return `El rango máximo es de ${MAX_DIAS_RANGO} días`
        return ''
      },

      consultar () {
        const error = this.validarRangoFechas()
        if (error) return this.validarError(error)
        this.reporte = null
        this.sinReporte = false
        this.conciliacion = null
        this.dialogDetalle = false
        this.limpiarFiltros()
        this.cargar = true
        const payload = { desde: this.fechaDesde, hasta: this.fechaHasta, comparar: this.comparar }
        return this.$http.post('api/meta/analyze/rango/' + this.idEscuela, payload)
          .then((response) => {
            const data = response.data || {}
            const ind = data.indicadores_homologados
            this.sinReporte = !ind || (!ind.dias_con_datos && !ind.global.gasto)
            this.reporte = this.sinReporte ? null : data
          })
          .catch((error) => { this.validarError(error) })
          .finally(() => { this.cargar = false })
      },
    },
  }
</script>

<style scoped>
  .alerta-gasto {
    background-color: #ffebee;
  }
  .alerta-conversaciones {
    background-color: #fff3e0;
  }
  .fila-clic {
    cursor: pointer;
  }
</style>
